var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 72 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_645",
  "data-name": "Path 645",
  d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
  fill: "#fff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "man_is_carrying_a_heavy_safe",
  "data-name": "man is carrying a heavy safe",
  transform: "translate(-259.996 -220.155)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path9",
  d: "M362.921,1839.014a7.412,7.412,0,0,1,.825,2.1s3.78,1.028,6.323-1.2c0,0-.321-.845-.653-1.591-.469-1.052-1.066-2.085-1.066-2.085S365.877,1839.426,362.921,1839.014Z",
  transform: "translate(-90.956 -1573.248)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path11",
  d: "M361.779,1837.413a8.85,8.85,0,0,1-2.079-.239.088.088,0,0,1-.042-.026.088.088,0,0,1-.022-.044,7.348,7.348,0,0,0-.814-2.067.087.087,0,0,1,.087-.131,5.247,5.247,0,0,0,3.755-1.218,9.426,9.426,0,0,0,1.594-1.532.088.088,0,0,1,.075-.034.088.088,0,0,1,.07.043c.006.011.6,1.05,1.069,2.094.329.739.652,1.585.655,1.595a.088.088,0,0,1-.024.1,6.462,6.462,0,0,1-4.171,1.461Zm-1.98-.394a8.95,8.95,0,0,0,2.136.219,6.313,6.313,0,0,0,4.009-1.378c-.077-.2-.351-.9-.629-1.529-.373-.838-.834-1.674-1-1.968a9.853,9.853,0,0,1-1.541,1.463,5.425,5.425,0,0,1-3.716,1.276A7.149,7.149,0,0,1,359.8,1837.019Z",
  transform: "translate(-86.933 -1569.227)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path13",
  d: "M396.786,1882.354a3.577,3.577,0,0,1,.59,1.335s3.466.545,5.275-1.044c0,0-.228-.489-.464-1.019-.334-.748-.722-1.546-.722-1.546S398.889,1882.648,396.786,1882.354Z",
  transform: "translate(-124.105 -1616.171)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path15",
  d: "M396.035,1881.188a10.015,10.015,0,0,1-1.392-.091.058.058,0,0,1-.032-.016.057.057,0,0,1-.016-.031,3.541,3.541,0,0,0-.58-1.31.059.059,0,0,1-.011-.031.058.058,0,0,1,.033-.055.057.057,0,0,1,.033-.006c2.049.286,4.605-2.231,4.631-2.257a.057.057,0,0,1,.023-.014.059.059,0,0,1,.027,0,.06.06,0,0,1,.025.011.059.059,0,0,1,.017.021c0,.008.392.807.723,1.546.232.524.461,1.013.464,1.018a.058.058,0,0,1,0,.036.059.059,0,0,1-.018.032,5.676,5.676,0,0,1-3.351,1.132C396.413,1881.184,396.218,1881.188,396.035,1881.188Zm-1.332-.2c.39.053,3.483.42,5.154-1.005-.059-.127-.251-.541-.446-.98-.271-.61-.583-1.26-.686-1.473a11.78,11.78,0,0,1-1.5,1.2,5.2,5.2,0,0,1-3.04,1.05A3.5,3.5,0,0,1,394.7,1880.989Z",
  transform: "translate(-121.382 -1613.521)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path17",
  d: "M1754.26,2306.382c.894.825,4.227,5.4,5.1,8.832l-.722.481h2.234a30.4,30.4,0,0,0-3.172-9.726Z",
  transform: "translate(-1452.878 -2033.056)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path19",
  d: "M1756.841,2311.763h-2.234a.087.087,0,0,1-.082-.116.085.085,0,0,1,.033-.043l.67-.447a25.737,25.737,0,0,0-5.056-8.73.087.087,0,0,1-.025-.042.084.084,0,0,1,0-.049.086.086,0,0,1,.072-.06l3.437-.412a.091.091,0,0,1,.05.009.089.089,0,0,1,.036.035,30.756,30.756,0,0,1,3.183,9.758.084.084,0,0,1,0,.037.087.087,0,0,1-.083.061Zm-1.947-.174h1.847a30.562,30.562,0,0,0-3.12-9.546l-3.2.384c1.059,1.1,4.161,5.461,4.992,8.746a.088.088,0,0,1-.036.094Z",
  transform: "translate(-1448.849 -2029.036)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path21",
  d: "M1962.463,2700.03c-.193-.077-.039-.541-.309-.7a1.208,1.208,0,0,0-.525-.082,5.944,5.944,0,0,1,.293.928l-.722.482h2.234a4.835,4.835,0,0,1-.1-.521A2.4,2.4,0,0,1,1962.463,2700.03Z",
  transform: "translate(-1655.442 -2418.022)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path23",
  d: "M1960.747,2697.994h-2.234a.058.058,0,0,1-.056-.041.058.058,0,0,1,.023-.065l.69-.46a6.2,6.2,0,0,0-.283-.88.057.057,0,0,1,0-.027.059.059,0,0,1,.009-.026.058.058,0,0,1,.047-.026,1.272,1.272,0,0,1,.55.087l.005,0a.551.551,0,0,1,.217.454c.015.116.027.215.084.238a2.414,2.414,0,0,0,.846.107.06.06,0,0,1,.058.049,4.867,4.867,0,0,0,.1.514.063.063,0,0,1,0,.027.062.062,0,0,1-.011.024.059.059,0,0,1-.02.017.062.062,0,0,1-.026.006Zm-2.042-.116h1.968c-.018-.077-.047-.21-.077-.4a2.418,2.418,0,0,1-.838-.116c-.12-.048-.139-.193-.157-.332s-.039-.3-.155-.366a1.054,1.054,0,0,0-.414-.077,5.389,5.389,0,0,1,.265.862.058.058,0,0,1-.025.058Z",
  transform: "translate(-1652.755 -2415.296)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path25",
  d: "M1757.7,2306.04l-3.437.413a15.27,15.27,0,0,1,2.121,2.761,18.375,18.375,0,0,1,2.486-.748A12.4,12.4,0,0,0,1757.7,2306.04Z",
  transform: "translate(-1452.878 -2033.124)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path27",
  d: "M1993.3,2740.795a.055.055,0,0,1-.018,0l-.562-.183a.058.058,0,0,1-.007-.106.059.059,0,0,1,.043,0l.562.183a.06.06,0,0,1,.031.025.057.057,0,0,1,.008.039.058.058,0,0,1-.056.049Z",
  transform: "translate(-1686.261 -2458.395)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path29",
  d: "M1834.892,2379.828l-.008,0a.015.015,0,0,1-.005-.007.014.014,0,0,1,0-.006.011.011,0,0,1,0-.005l0,0,.005,0a7.21,7.21,0,0,1,1.124-.3.014.014,0,0,1,.01,0,.015.015,0,0,1,.005.009.014.014,0,0,1-.01.017,7.259,7.259,0,0,0-1.121.3Z",
  transform: "translate(-1531.79 -2105.03)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path31",
  d: "M1888.495,2390.069l-.008,0a.018.018,0,0,1-.005-.007.021.021,0,0,1,0-.006.025.025,0,0,1,0-.006l0,0,0,0a2.291,2.291,0,0,1,.714-.162h.006l.005,0,0,0a.015.015,0,0,1,0,.006.013.013,0,0,1,0,.006l0,0,0,0h-.005a2.28,2.28,0,0,0-.706.16Z",
  transform: "translate(-1584.26 -2115.191)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path33",
  d: "M1879.3,2420.214l-.008,0a.015.015,0,0,1-.005-.007.014.014,0,0,1,0-.011.015.015,0,0,1,.008-.008l.55-.183a.015.015,0,0,1,.011,0,.016.016,0,0,1,.007.008.019.019,0,0,1,0,.006.015.015,0,0,1,0,.005l0,0,0,0-.55.184Z",
  transform: "translate(-1575.255 -2144.676)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path35",
  d: "M1933.446,2403.95a.015.015,0,0,1-.009,0,.016.016,0,0,1-.005-.009.015.015,0,0,1,0-.011.016.016,0,0,1,.009-.006l.138-.023h.005l.005,0,0,0a.011.011,0,0,1,0,.005.01.01,0,0,1,0,.005.012.012,0,0,1,0,.005l0,0-.005,0-.138.023Z",
  transform: "translate(-1628.26 -2128.914)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path37",
  d: "M1855.96,2418.589a.014.014,0,0,1-.01,0,.016.016,0,0,1-.005-.009.015.015,0,0,1,0-.01.012.012,0,0,1,.009-.006l.229-.068a.015.015,0,0,1,.018.01.016.016,0,0,1,0,.011.014.014,0,0,1-.009.007l-.229.068Z",
  transform: "translate(-1552.412 -2143.199)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path39",
  d: "M1922.064,2366.551a.014.014,0,0,1-.009,0l0,0a.016.016,0,0,1,0-.006.012.012,0,0,1,0-.005l0,0a.112.112,0,0,1,.132-.027l0,0a.012.012,0,0,1,0,.005.016.016,0,0,1,0,.006l0,.005,0,0,0,0h-.005l-.005,0a.084.084,0,0,0-.052-.006.088.088,0,0,0-.045.026.012.012,0,0,1-.006,0Z",
  transform: "translate(-1617.12 -2092.295)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path41",
  d: "M1980.4,2608.157h-.361a.038.038,0,0,1-.027-.011.039.039,0,0,1,.027-.066h.361a.039.039,0,0,1,.027.066A.038.038,0,0,1,1980.4,2608.157Z",
  transform: "translate(-1673.845 -2328.778)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path43",
  d: "M1982.623,2593.537h-.155a.039.039,0,1,1,0-.077h.155a.038.038,0,0,1,.027.011.039.039,0,0,1,0,.055A.038.038,0,0,1,1982.623,2593.537Z",
  transform: "translate(-1676.223 -2314.467)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path45",
  d: "M889.548,2382.508s0,4.742,1.031,7.492l-.721.481h2.233s-.756-2.646.413-8.111Z",
  transform: "translate(-606.449 -2107.84)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path47",
  d: "M888.172,2386.53h-2.234a.09.09,0,0,1-.052-.017.088.088,0,0,1-.03-.1.089.089,0,0,1,.034-.043l.667-.443a27.793,27.793,0,0,1-1.013-7.458.086.086,0,0,1,.083-.087l2.956-.138a.084.084,0,0,1,.039.007.086.086,0,0,1,.032.024.092.092,0,0,1,.018.035.088.088,0,0,1,0,.039c-1.149,5.374-.421,8.042-.414,8.069a.089.089,0,0,1,0,.04.092.092,0,0,1-.016.037.087.087,0,0,1-.032.025A.086.086,0,0,1,888.172,2386.53Zm-1.946-.174h1.836c-.123-.555-.584-3.188.414-7.931l-2.759.128a26.744,26.744,0,0,0,1.025,7.378.088.088,0,0,1,0,.058.089.089,0,0,1-.035.046Z",
  transform: "translate(-602.529 -2103.803)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path49",
  d: "M891.923,2384.693a22.815,22.815,0,0,1,.413-2.323l-2.956.138a20.393,20.393,0,0,0,.094,2.274C890.255,2384.807,891.136,2384.72,891.923,2384.693Z",
  transform: "translate(-606.28 -2107.84)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path51",
  d: "M905.44,2700.03c-.193-.077-.039-.541-.309-.7a1.206,1.206,0,0,0-.525-.082c.087.327.184.638.293.928l-.722.482h2.233a4.892,4.892,0,0,1-.1-.521A2.408,2.408,0,0,1,905.44,2700.03Z",
  transform: "translate(-620.768 -2418.022)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path53",
  d: "M903.707,2698.065h-2.234a.058.058,0,0,1-.056-.041.058.058,0,0,1,0-.036.059.059,0,0,1,.023-.029l.684-.456c-.1-.268-.193-.567-.278-.889a.059.059,0,0,1,0-.026.058.058,0,0,1,.011-.023.057.057,0,0,1,.02-.017.061.061,0,0,1,.025-.006,1.271,1.271,0,0,1,.549.087l.005,0a.549.549,0,0,1,.216.454c.015.116.028.215.085.238a2.419,2.419,0,0,0,.846.107.057.057,0,0,1,.039.014.059.059,0,0,1,.02.035,4.787,4.787,0,0,0,.1.514.058.058,0,0,1-.01.051.06.06,0,0,1-.021.017.058.058,0,0,1-.026.006Zm-2.041-.116h1.968c-.018-.077-.047-.21-.077-.4a2.416,2.416,0,0,1-.838-.116h0c-.121-.048-.14-.193-.157-.332s-.039-.3-.157-.366a1.068,1.068,0,0,0-.423-.077c.085.309.176.595.271.851a.058.058,0,0,1,0,.038.056.056,0,0,1-.023.03Z",
  transform: "translate(-618.064 -2415.367)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path55",
  d: "M935.94,2740.709a.053.053,0,0,1-.022,0l-.447-.183a.053.053,0,0,1-.02-.012.054.054,0,0,1-.014-.019.059.059,0,0,1-.005-.023.057.057,0,0,1,0-.023.058.058,0,0,1,.013-.02.057.057,0,0,1,.043-.016.056.056,0,0,1,.023.006l.447.183a.059.059,0,0,1,.029.026.058.058,0,0,1-.014.072.06.06,0,0,1-.036.013Z",
  transform: "translate(-651.363 -2458.309)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path57",
  d: "M908.4,2436.614a.014.014,0,0,1-.009,0,.012.012,0,0,1,0-.008.015.015,0,0,1,0-.011.014.014,0,0,1,.009-.006,2.1,2.1,0,0,1,.669-.046l.005,0,0,0,0,0a.015.015,0,0,1,0,.006.022.022,0,0,1,0,.006l0,0,0,0h-.006a2.067,2.067,0,0,0-.66.045Z",
  transform: "translate(-624.887 -2160.855)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path59",
  d: "M922.879,2450.9a.014.014,0,0,1-.01,0,.015.015,0,0,1,0-.01.014.014,0,0,1,0-.005l0,0,0,0h.006l1.192-.023a.015.015,0,0,1,.014.02l0,0,0,0h-.006l-1.191.023Z",
  transform: "translate(-639.061 -2174.873)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path61",
  d: "M975.574,2441.131a.015.015,0,0,1-.014-.019l0-.005,0,0h.005l.275-.024a.014.014,0,0,1,.011,0,.014.014,0,0,1,.005.01.016.016,0,0,1,0,.011.016.016,0,0,1-.01.005l-.275.023Z",
  transform: "translate(-690.642 -2165.308)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path63",
  d: "M909.475,2480.161a.015.015,0,0,1-.01,0,.015.015,0,0,1,0-.01.015.015,0,0,1,0-.006l0,0,0,0h.005l.55-.021a.015.015,0,0,1,.01,0,.016.016,0,0,1,0,.01.015.015,0,0,1,0,.01.013.013,0,0,1-.01,0l-.55.022Z",
  transform: "translate(-625.94 -2203.514)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path65",
  d: "M954.624,2468.579h-.183a.014.014,0,0,1-.01,0,.014.014,0,0,1,0-.01.015.015,0,0,1,0-.006l0,0,0,0h.194l0,0,0,0a.016.016,0,0,1,0,.006.016.016,0,0,1,0,.006l0,0,0,0Z",
  transform: "translate(-669.955 -2192.198)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path67",
  d: "M939.423,2593.537h-.464a.038.038,0,0,1-.027-.011.039.039,0,0,1,0-.055.038.038,0,0,1,.027-.011h.464a.038.038,0,0,1,.027.011.039.039,0,0,1,0,.055A.038.038,0,0,1,939.423,2593.537Z",
  transform: "translate(-654.777 -2314.467)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path69",
  d: "M612.354,2766.037H577.177a.039.039,0,1,1,0-.077h35.177a.039.039,0,0,1,.039.039.04.04,0,0,1-.011.028A.039.039,0,0,1,612.354,2766.037Z",
  transform: "translate(-300.644 -2483.32)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path71",
  d: "M1404.611,1845.46a14.761,14.761,0,0,0-.316,1.564,18.523,18.523,0,0,0,2.433,11.507l8.713-2.493c-1.838-3.321-2.1-6.225-.406-8.687a8.3,8.3,0,0,1,1.132-1.311c-3.016-.09-6.03-.2-9.044-.383C1406.28,1845.583,1405.435,1845.571,1404.611,1845.46Z",
  transform: "translate(-1110.157 -1582.282)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "path73",
  d: "M1402.782,1854.647a.086.086,0,0,1-.073-.039,18.609,18.609,0,0,1-2.446-11.566,14.8,14.8,0,0,1,.318-1.573.086.086,0,0,1,.036-.05.088.088,0,0,1,.06-.014c.513.069,1.044.1,1.558.131.309.019.633.039.95.064,3.17.194,6.348.3,9.04.383a.087.087,0,0,1,.077.056.087.087,0,0,1-.022.094,8.227,8.227,0,0,0-1.121,1.3c-1.621,2.358-1.487,5.169.41,8.6a.088.088,0,0,1-.052.128l-8.712,2.493Zm-2.052-13.061a14.5,14.5,0,0,0-.3,1.48,17.407,17.407,0,0,0,.867,8.062,18.033,18.033,0,0,0,1.519,3.33l8.544-2.445a11.14,11.14,0,0,1-1.485-4.607,6.388,6.388,0,0,1,1.136-4.076,8.239,8.239,0,0,1,1-1.182c-2.649-.08-5.749-.187-8.842-.377-.317-.027-.638-.046-.947-.064C1401.732,1841.679,1401.225,1841.65,1400.73,1841.587Z",
  transform: "translate(-1106.211 -1578.313)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path75",
  d: "M1702.956,2365.553a.058.058,0,0,1-.056-.048.058.058,0,0,1,.036-.065l.481-.173a.058.058,0,0,1,.07.036.059.059,0,0,1,0,.043.058.058,0,0,1-.03.03l-.48.174a.056.056,0,0,1-.019,0Z",
  transform: "translate(-1402.602 -2091.097)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path77",
  d: "M1733.667,2101.77a.055.055,0,0,1-.019,0,5.29,5.29,0,0,0-1.562-.282.058.058,0,0,1-.056-.06.057.057,0,0,1,.018-.04.059.059,0,0,1,.042-.016,5.42,5.42,0,0,1,1.6.288.058.058,0,0,1,.031.025.059.059,0,0,1,.007.039.056.056,0,0,1-.02.035A.058.058,0,0,1,1733.667,2101.77Z",
  transform: "translate(-1431.117 -1832.781)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path79",
  d: "M1771.4,2121.306h-.309a.058.058,0,0,1-.058-.058.058.058,0,0,1,.017-.041.059.059,0,0,1,.041-.017h.309a.058.058,0,0,1,0,.116Z",
  transform: "translate(-1469.293 -1852.182)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path81",
  d: "M740.249,336.331l-17.42-9.247a.44.44,0,0,0-.595.182l-13.048,24.581a.439.439,0,0,0,.182.594l17.42,9.247a.439.439,0,0,0,.594-.182l13.048-24.581A.44.44,0,0,0,740.249,336.331Z",
  transform: "translate(-429.851 -95.96)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path83",
  d: "M722.94,357.829a.523.523,0,0,1-.246-.062h0l-17.42-9.248a.528.528,0,0,1-.218-.712l13.048-24.58a.528.528,0,0,1,.712-.218l17.42,9.247a.528.528,0,0,1,.218.712l-13.049,24.581a.527.527,0,0,1-.466.28Zm-.164-.215a.353.353,0,0,0,.477-.146L736.3,332.887a.353.353,0,0,0-.146-.476l-17.42-9.249a.354.354,0,0,0-.476.146l-13.049,24.582a.354.354,0,0,0,.146.477l17.421,9.248Z",
  transform: "translate(-425.798 -91.962)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path85",
  d: "M1220.726,900.709a4.966,4.966,0,1,1,3.506-1.455,4.962,4.962,0,0,1-3.506,1.455Zm0-9.8a4.848,4.848,0,1,0,3.424,1.42,4.844,4.844,0,0,0-3.424-1.42Z",
  transform: "translate(-925.768 -647.796)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path87",
  d: "M1355.648,1032.7a2.049,2.049,0,1,1,1.446-.6,2.047,2.047,0,0,1-1.446.6Zm0-3.977a1.933,1.933,0,1,0,1.364.566,1.931,1.931,0,0,0-1.364-.566Z",
  transform: "translate(-1060.691 -782.701)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path89",
  d: "M821.069,451.906a.438.438,0,0,1-.2-.051L806.25,444.1a.441.441,0,0,1-.182-.6l11.74-22.115a.441.441,0,0,1,.595-.182l14.614,7.758a.441.441,0,0,1,.182.6l-11.74,22.115a.436.436,0,0,1-.26.214.45.45,0,0,1-.13.02ZM818.2,421.268a.325.325,0,0,0-.287.172l-11.74,22.115a.325.325,0,0,0,.134.44l14.614,7.757a.325.325,0,0,0,.438-.134L833.1,429.5a.325.325,0,0,0-.134-.438l-14.614-7.758a.323.323,0,0,0-.151-.039Z",
  transform: "translate(-524.683 -188.091)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path91",
  d: "M916.354,1054.452l-.452.619c-.967-.422-1.645-.978-1.258-.986A5.333,5.333,0,0,1,916.354,1054.452Z",
  transform: "translate(-630.906 -807.639)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path93",
  d: "M911.891,1051.185a.085.085,0,0,1-.035-.007c-.619-.271-1.469-.77-1.418-1.031.009-.044.046-.118.193-.121a5.336,5.336,0,0,1,1.743.372.088.088,0,0,1,.033.022.089.089,0,0,1,.019.034.086.086,0,0,1,0,.039.089.089,0,0,1-.015.036l-.452.619a.087.087,0,0,1-.03.027A.09.09,0,0,1,911.891,1051.185Zm-1.27-.985a3.623,3.623,0,0,0,1.241.79l.343-.47a5.03,5.03,0,0,0-1.57-.321Z",
  transform: "translate(-626.895 -803.666)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path95",
  d: "M880.463,1068.664c-.441-.039-1.709.135-1.731.488-.016.245.48.218.48.218s-.513.155-.541.41.464.267.464.267-.483.149-.43.437c.046.247.616.223,1.132.345a13.663,13.663,0,0,1,2.709,1.32s1.185-3.026,1.111-3.019A21.193,21.193,0,0,0,880.463,1068.664Z",
  transform: "translate(-595.8 -821.906)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path97",
  d: "M878.528,1068.227a.085.085,0,0,1-.051-.017,13.907,13.907,0,0,0-2.677-1.305c-.155-.036-.314-.059-.467-.082-.369-.053-.688-.1-.731-.332a.414.414,0,0,1,.232-.413.454.454,0,0,1-.2-.12.248.248,0,0,1-.06-.2.521.521,0,0,1,.3-.35.389.389,0,0,1-.165-.092.232.232,0,0,1-.068-.182.3.3,0,0,1,.116-.207,3.264,3.264,0,0,1,1.7-.364h.017a21.6,21.6,0,0,1,3.192.47.093.093,0,0,1,.047.032c.041.054.057.077-.527,1.615-.281.739-.571,1.48-.574,1.488a.084.084,0,0,1-.022.033.087.087,0,0,1-.035.019A.084.084,0,0,1,878.528,1068.227Zm-3.331-2.953a.087.087,0,0,1,.025.17c-.15.045-.464.187-.481.336a.073.073,0,0,0,0,.033.074.074,0,0,0,.017.029.6.6,0,0,0,.359.108.087.087,0,0,1,.023.17s-.408.133-.37.339c.02.11.307.151.585.193.15.021.32.046.482.084a13.454,13.454,0,0,1,2.646,1.274c.389-1,.959-2.487,1.056-2.824a21.13,21.13,0,0,0-3.092-.445h-.009a3.2,3.2,0,0,0-1.581.322.144.144,0,0,0-.056.085.059.059,0,0,0,0,.027.06.06,0,0,0,.015.022.634.634,0,0,0,.371.077Z",
  transform: "translate(-591.785 -817.896)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path99",
  d: "M903.185,1145.723h0a.055.055,0,0,1-.022-.006.058.058,0,0,1-.018-.014.056.056,0,0,1-.011-.02.056.056,0,0,1,0-.022l.011-.145a.057.057,0,0,1,.006-.022.059.059,0,0,1,.014-.018.054.054,0,0,1,.02-.011.056.056,0,0,1,.023,0,.057.057,0,0,1,.022.006.065.065,0,0,1,.018.014.061.061,0,0,1,.011.02.056.056,0,0,1,0,.022l-.011.145a.058.058,0,0,1-.058.054Z",
  transform: "translate(-619.74 -897.084)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path101",
  d: "M905.141,1113.413h0a.058.058,0,0,1-.051-.04.058.058,0,0,1,0-.022l.011-.145a.059.059,0,0,1,.02-.04.054.054,0,0,1,.02-.011.061.061,0,0,1,.023,0,.062.062,0,0,1,.022.006.058.058,0,0,1,.029.034.057.057,0,0,1,0,.022l-.011.145a.058.058,0,0,1-.058.054Z",
  transform: "translate(-621.655 -865.458)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path103",
  d: "M908.507,1081.613h0a.058.058,0,0,1-.04-.02.059.059,0,0,1-.014-.042l.011-.145a.057.057,0,0,1,.006-.022.059.059,0,0,1,.014-.018.065.065,0,0,1,.02-.011.059.059,0,0,1,.023,0,.06.06,0,0,1,.022.006.055.055,0,0,1,.018.014.058.058,0,0,1,.014.042l-.011.145a.058.058,0,0,1-.018.038A.057.057,0,0,1,908.507,1081.613Z",
  transform: "translate(-624.95 -834.33)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path105",
  d: "M2512.278,805.105a1.73,1.73,0,0,1-.539,1.752s2.011,1.1,1.988.481a5.349,5.349,0,0,1,.265-2.385Z",
  transform: "translate(-2194.342 -563.776)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path107",
  d: "M2510.828,804.9a5.7,5.7,0,0,1-1.782-.675.06.06,0,0,1-.02-.018.059.059,0,0,1-.01-.025.06.06,0,0,1,0-.027.057.057,0,0,1,.015-.023,1.657,1.657,0,0,0,.523-1.691.059.059,0,0,1,0-.026.056.056,0,0,1,.009-.025.057.057,0,0,1,.044-.026l1.715-.151a.055.055,0,0,1,.03.005.057.057,0,0,1,.033.049.058.058,0,0,1-.007.03,5.413,5.413,0,0,0-.258,2.356.213.213,0,0,1-.1.2A.368.368,0,0,1,2510.828,804.9Zm-1.658-.739c.6.32,1.56.739,1.789.6a.1.1,0,0,0,.044-.1,6.224,6.224,0,0,1,.232-2.32l-1.549.135A1.816,1.816,0,0,1,2509.17,804.165Z",
  transform: "translate(-2191.675 -561.097)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path109",
  d: "M2533.906,806.934a2,2,0,0,1-.106.948l1.58-.271.134-.938Z",
  transform: "translate(-2215.935 -565.46)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path111",
  d: "M991.8,1075.23a18.924,18.924,0,0,0-1.905-.34,23.184,23.184,0,0,0-.744,2.51,16.376,16.376,0,0,1,1.538.848S991.872,1075.222,991.8,1075.23Z",
  transform: "translate(-703.945 -828.005)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path113",
  d: "M1005.137,991.514c-.013-.025-.066-.039-.025-.084a.105.105,0,0,1,.125-.023c.028.024.019.082-.016.123S1005.161,991.543,1005.137,991.514Z",
  transform: "translate(-719.555 -746.275)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path115",
  d: "M1689.125,797.052c-.016-.017-.039-.034-.028-.058s.049-.023.077-.023a.072.072,0,0,1,.065.048.221.221,0,0,1,0,.084.434.434,0,0,1-.084-.013C1689.146,797.085,1689.136,797.065,1689.125,797.052Z",
  transform: "translate(-1389.089 -555.96)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path117",
  d: "M1657.585,737.648c-.033.02-.045,0-.062-.018a.074.074,0,0,1-.026-.049.079.079,0,0,1,0-.028.072.072,0,0,1,.014-.025.068.068,0,0,1,.041,0,.067.067,0,0,1,.036.02.1.1,0,0,1,.013.054.1.1,0,0,1-.018.052Z",
  transform: "translate(-1358.16 -497.77)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path119",
  d: "M1145.109,1468.163c-.033.02-.045,0-.062-.018a.076.076,0,0,1-.018-.022.074.074,0,0,1-.008-.027.07.07,0,0,1,0-.028.038.038,0,0,1,.055-.03.07.07,0,0,1,.036.02.1.1,0,0,1,.012.054.1.1,0,0,1-.019.052Z",
  transform: "translate(-856.52 -1212.838)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path121",
  d: "M1228.119,876.219c-.016-.015-.036-.032-.017-.058a.092.092,0,0,1,.111,0c.026.024.008.039-.009.058S1228.149,876.266,1228.119,876.219Z",
  transform: "translate(-937.837 -633.46)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path123",
  d: "M1652.505,665.067c.019-.018.036-.012.039,0,.01.033.081-.015.065.052-.007.028,0,.059-.039.065s-.036-.026-.052-.041S1652.518,665.091,1652.505,665.067Z",
  transform: "translate(-1353.273 -426.836)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path125",
  d: "M1778.248,781.515c-.026.025-.044.009-.059-.01s-.051-.039-.016-.071a.067.067,0,0,1,.081-.007.069.069,0,0,1,.013.045.068.068,0,0,1-.019.043Z",
  transform: "translate(-1476.271 -540.738)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path127",
  d: "M1820.436,1302.929c-.026.025-.044.009-.058-.01s-.051-.039-.016-.071a.055.055,0,0,1,.018-.015.056.056,0,0,1,.023-.006.057.057,0,0,1,.043.018.055.055,0,0,1,.014.044.053.053,0,0,1-.008.022.057.057,0,0,1-.016.017Z",
  transform: "translate(-1517.566 -1051.122)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path129",
  d: "M1608.228,1029.836c-.026.025-.044.009-.059-.01s-.051-.039-.016-.071a.067.067,0,0,1,.081-.007.069.069,0,0,1,.013.045.067.067,0,0,1-.019.043Z",
  transform: "translate(-1309.846 -783.808)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path131",
  d: "M1823.007,865.61c-.026.025-.044.009-.059-.01s-.051-.039-.016-.071a.065.065,0,0,1,.039-.017.066.066,0,0,1,.041.01.068.068,0,0,1,.013.045.069.069,0,0,1-.019.043Z",
  transform: "translate(-1520.084 -623.055)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path133",
  d: "M1997.081,978.6c.012-.008.029-.039.048-.014a.081.081,0,0,1,0,.069.123.123,0,0,1-.052.048l-.013,0-.013,0-.011-.007a.032.032,0,0,1-.007-.011c-.005-.009-.01-.026-.005-.032A.51.51,0,0,1,1997.081,978.6Z",
  transform: "translate(-1690.508 -733.729)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path135",
  d: "M1951.8,846.3a.223.223,0,0,1,.017-.081c.023-.036.047-.013.068.012s.035.033.015.058A.131.131,0,0,1,1951.8,846.3Z",
  transform: "translate(-1646.241 -604.147)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path137",
  d: "M868.483,1326.914a.22.22,0,0,1,.016-.081c.024-.036.048-.013.068.011s.035.033.015.059a.133.133,0,0,1-.1.011Z",
  transform: "translate(-585.829 -1074.603)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path139",
  d: "M1427.109,1066.992c-.024,0-.059.005-.068-.006a.075.075,0,0,1-.012-.046.074.074,0,0,1,.019-.044.028.028,0,0,1,.009-.008.027.027,0,0,1,.012,0l.013,0a.03.03,0,0,1,.01.007C1427.13,1066.92,1427.105,1066.958,1427.109,1066.992Z",
  transform: "translate(-1132.566 -820.168)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path141",
  d: "M1471.77,1050.144a.237.237,0,0,1-.029-.047c0-.007.007-.02.014-.029a.027.027,0,0,1,.009-.009.028.028,0,0,1,.012,0,.027.027,0,0,1,.013,0,.028.028,0,0,1,.011.007c.033.028.013.065.013.1Z",
  transform: "translate(-1176.332 -803.694)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path143",
  d: "M1539.123,987.218a.021.021,0,0,1-.006-.01.022.022,0,0,1,0-.012.023.023,0,0,1,.005-.01.022.022,0,0,1,.01-.007c.021-.011.032-.058.063-.026a.065.065,0,0,1,0,.065C1539.179,987.23,1539.146,987.219,1539.123,987.218Z",
  transform: "translate(-1242.282 -742.113)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path145",
  d: "M1707.84,769.591c-.032-.008-.072.012-.1-.025a.084.084,0,0,1-.005-.032c.032.007.071-.011.1.025a.087.087,0,0,1,.005.032Z",
  transform: "translate(-1407.34 -529.105)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path147",
  d: "M1818.479,993.309a.035.035,0,0,1-.006-.025.034.034,0,0,1,.013-.022c.025-.022.043-.011.057.01a.03.03,0,0,1,.007.024.034.034,0,0,1,0,.012.034.034,0,0,1-.009.009C1818.511,993.34,1818.5,993.325,1818.479,993.309Z",
  transform: "translate(-1515.733 -748.091)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path149",
  d: "M1943.425,923.108c-.013-.012-.021-.027,0-.039s.02.007.029.013.021.026,0,.039S1943.435,923.113,1943.425,923.108Z",
  transform: "translate(-1638.03 -679.394)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path151",
  d: "M1926.422,918.7c-.005-.024.014-.031.027-.042a.028.028,0,0,1,.014,0,.028.028,0,0,1,.011.007c.007.022-.014.03-.027.039S1926.43,918.7,1926.422,918.7Z",
  transform: "translate(-1621.399 -675.076)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path153",
  d: "M1552.273,859.961c.012-.013.027-.021.039,0s-.007.02-.013.029-.026.021-.038,0S1552.269,859.971,1552.273,859.961Z",
  transform: "translate(-1255.148 -617.608)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path155",
  d: "M1768.04,788.572c-.005-.024.015-.031.027-.042s.023,0,.025.008c.007.022-.014.03-.027.039S1768.048,788.574,1768.04,788.572Z",
  transform: "translate(-1466.365 -547.699)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path157",
  d: "M1363.532,954.5c-.005-.024.015-.031.027-.042a.029.029,0,0,1,.013,0,.03.03,0,0,1,.011.007c.007.022-.014.03-.027.039S1363.54,954.505,1363.532,954.5Z",
  transform: "translate(-1070.41 -710.122)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path159",
  d: "M833.15,1560.192c-.005-.024.015-.032.027-.042a.026.026,0,0,1,.013,0,.025.025,0,0,1,.011.007c.007.021-.014.03-.027.038S833.158,1560.194,833.15,1560.192Z",
  transform: "translate(-551.242 -1303.005)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path161",
  d: "M2137.4,855.757c-.005-.024.014-.032.027-.042a.031.031,0,0,1,.014,0,.025.025,0,0,1,.011.007c.007.022-.014.03-.027.039S2137.41,855.759,2137.4,855.757Z",
  transform: "translate(-1827.918 -613.464)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path163",
  d: "M1522.716,939.47l-.006-.026h.016a.139.139,0,0,1,.008.026Z",
  transform: "translate(-1226.223 -695.423)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path165",
  d: "M1914.61,860.324v-.018a.117.117,0,0,1,.025.01s0,.011,0,.017Z",
  transform: "translate(-1609.837 -617.958)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path167",
  d: "M1565.33,919.627v-.016a.049.049,0,0,1,.027,0c.016.006.016.017,0,.022a.07.07,0,0,1-.027-.005Z",
  transform: "translate(-1267.942 -676.007)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path169",
  d: "M1567.212,919.623c.009,0,.024,0,.026.005s0,.022-.012.019a.135.135,0,0,1-.027-.014Z",
  transform: "translate(-1269.773 -676.021)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path171",
  d: "M1412.3,785.885c.032.032.044.06-.007.1s-.059-.007-.082-.031-.046-.062.005-.1S1412.281,785.858,1412.3,785.885Z",
  transform: "translate(-1118.037 -545.064)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path173",
  d: "M1505.361,704.463c-.018-.034.006-.044.023-.059a.069.069,0,0,1,.023-.016.073.073,0,0,1,.055,0,.071.071,0,0,1,.023.016.068.068,0,0,1-.022.077.1.1,0,0,1-.1-.018Z",
  transform: "translate(-1209.235 -465.332)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path175",
  d: "M1034.915,996.281c.016.02.009.036-.007.039-.033.007.008.081-.057.059-.027-.009-.058-.008-.061-.045s.029-.033.045-.048S1034.889,996.291,1034.915,996.281Z",
  transform: "translate(-748.62 -751.052)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path177",
  d: "M919.662,1606.517c.016.02.009.036-.007.039-.033.008.008.081-.057.059-.027-.009-.058-.008-.061-.045s.029-.033.045-.048S919.638,1606.527,919.662,1606.517Z",
  transform: "translate(-635.803 -1348.386)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path179",
  d: "M1452.682,819.616c-.022-.028-.005-.044.015-.057s.041-.047.071-.01a.054.054,0,1,1-.086.067Z",
  transform: "translate(-1157.666 -578.046)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path181",
  d: "M884,1209.084c.007.013.039.032.01.049a.081.081,0,0,1-.068-.009.119.119,0,0,1-.043-.055.035.035,0,0,1,0-.013.032.032,0,0,1,.012-.022.03.03,0,0,1,.011-.006c.01,0,.027-.008.032,0a.484.484,0,0,1,.046.059Z",
  transform: "translate(-600.92 -959.301)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path183",
  d: "M1542.987,583a.208.208,0,0,1,.077.023c.033.026.009.048-.017.066s-.036.032-.059.01A.131.131,0,0,1,1542.987,583Z",
  transform: "translate(-1246.063 -346.518)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path185",
  d: "M1283.73,855.137c0-.032.023-.041.039-.055s.039-.024.058,0a.034.034,0,0,1,.009.015.03.03,0,0,1,0,.017.034.034,0,0,1-.009.015.032.032,0,0,1-.016.008.282.282,0,0,1-.081,0Z",
  transform: "translate(-992.296 -612.831)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path187",
  d: "M1269.22,693.861a.023.023,0,0,1-.006-.011.023.023,0,0,1,0-.012.022.022,0,0,1,.006-.01.024.024,0,0,1,.011-.006c.022-.009.039-.054.065-.02a.068.068,0,0,1,0,.033.065.065,0,0,1-.013.031C1269.274,693.878,1269.243,693.864,1269.22,693.861Z",
  transform: "translate(-978.087 -454.963)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path189",
  d: "M1472.86,751.4c.011-.031-.006-.072.033-.092a.1.1,0,0,1,.032,0c-.009.031.005.072-.032.092a.089.089,0,0,1-.033,0Z",
  transform: "translate(-1177.427 -511.26)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path191",
  d: "M1405.184,712.459l.012,0h.013l.011.005a.034.034,0,0,1,.009.009c.02.027.007.043-.014.056a.031.031,0,0,1-.012,0h-.013a.028.028,0,0,1-.011-.006.031.031,0,0,1-.008-.01C1405.151,712.488,1405.165,712.473,1405.184,712.459Z",
  transform: "translate(-1111.16 -473.232)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path193",
  d: "M1300.224,949.979c.021,0,.055,0,.063.013a.062.062,0,0,1,0,.033.061.061,0,0,1-.013.031c-.035.021-.039-.024-.058-.039S1300.2,949.991,1300.224,949.979Z",
  transform: "translate(-1008.426 -705.735)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path195",
  d: "M1330.3,837.979c.019-.014.039-.027.057,0a.149.149,0,0,1,.01.031h-.077Z",
  transform: "translate(-1037.872 -596.087)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path197",
  d: "M1458.106,476.346c.024,0,.03.017.039.031a.03.03,0,0,1,0,.013.028.028,0,0,1-.008.011c-.022.005-.028-.016-.039-.03S1458.1,476.354,1458.106,476.346Z",
  transform: "translate(-1162.975 -242.116)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path199",
  d: "M1254.116,736.383h.03a.157.157,0,0,1-.026.039c-.006.006-.021,0-.032,0a.041.041,0,0,1,.007-.025.042.042,0,0,1,.021-.016Z",
  transform: "translate(-963.281 -496.655)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path201",
  d: "M1122.692,1424.091c.024,0,.03.017.039.03a.025.025,0,0,1,0,.013.028.028,0,0,1-.008.011c-.022,0-.029-.017-.039-.03S1122.689,1424.1,1122.692,1424.091Z",
  transform: "translate(-834.653 -1169.822)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path203",
  d: "M1449.512,808.963c.024,0,.03.017.038.031a.027.027,0,0,1-.01.024c-.022.005-.029-.016-.039-.03S1449.509,808.971,1449.512,808.963Z",
  transform: "translate(-1154.563 -567.701)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path205",
  d: "M1184.132,975.709l.026,0c0,.006,0,.015,0,.016a.1.1,0,0,1-.026.006Z",
  transform: "translate(-894.802 -730.917)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path207",
  d: "M1482.271,417.024l.018,0a.122.122,0,0,1-.013.024s-.011,0-.016,0Z",
  transform: "translate(-1186.629 -184.049)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path209",
  d: "M1309.968,721.1l0,.027c-.006,0-.015,0-.016,0a.1.1,0,0,1-.006-.026Z",
  transform: "translate(-1017.962 -481.692)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path211",
  d: "M1214.01,972.341l0-.018a.1.1,0,0,1,.024.012s0,.011,0,.016Z",
  transform: "translate(-924.05 -727.607)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path213",
  d: "M1321.8,856.227l.018,0a.109.109,0,0,1-.012.024s-.011,0-.016,0Z",
  transform: "translate(-1029.552 -613.965)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path215",
  d: "M1658.929,941.4c-.016-.015-.036-.032-.017-.058a.092.092,0,0,1,.111,0c.026.024.008.039-.009.058S1658.959,941.452,1658.929,941.4Z",
  transform: "translate(-1359.538 -697.266)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path217",
  d: "M1714.54,920.448c0-.032.023-.041.039-.055s.039-.024.058,0a.032.032,0,0,1-.016.054.277.277,0,0,1-.081,0Z",
  transform: "translate(-1413.997 -676.761)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path219",
  d: "M1730.986,1015.24c.022,0,.056,0,.063.013a.068.068,0,0,1,0,.033.066.066,0,0,1-.012.031c-.035.021-.039-.023-.058-.038S1730.966,1015.252,1730.986,1015.24Z",
  transform: "translate(-1430.08 -769.616)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path221",
  d: "M1761.11,903.241c.019-.014.039-.027.057,0a.122.122,0,0,1,.01.031h-.077Z",
  transform: "translate(-1459.573 -659.97)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path223",
  d: "M1054.281,1576.628c.019-.014.039-.028.057,0a.123.123,0,0,1,.01.03h-.077Z",
  transform: "translate(-767.688 -1319.119)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path225",
  d: "M2191.143,1389.884l.026,0c0,.005,0,.015,0,.016a.123.123,0,0,1-.026.006Z",
  transform: "translate(-1880.52 -1136.335)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path227",
  d: "M1643.94,1069.458l0-.018a.127.127,0,0,1,.024.013s0,.011,0,.016Z",
  transform: "translate(-1344.89 -822.67)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path229",
  d: "M1752.611,921.489l.018,0a.111.111,0,0,1-.013.024s-.011,0-.016,0Z",
  transform: "translate(-1451.253 -677.847)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path231",
  d: "M965.163,1445.83c.006,0,0,.03,0,.056,0,.008-.005.02-.011.022s-.139-.051-.137-.073,0-.052.022-.072.039,0,.059,0S965.129,1445.8,965.163,1445.83Z",
  transform: "translate(-680.317 -1191.029)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path233",
  d: "M1649.349,1049.074a.069.069,0,0,1-.018-.022.064.064,0,0,1-.008-.028.066.066,0,0,1,0-.028.067.067,0,0,1,.015-.024c.019-.02.089,0,.1.018a.078.078,0,0,1,.013.031.079.079,0,0,1,0,.033.077.077,0,0,1-.014.03.08.08,0,0,1-.025.022C1649.375,1049.136,1649.367,1049.095,1649.349,1049.074Z",
  transform: "translate(-1350.16 -802.626)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path235",
  d: "M960.969,1499.117c.008.023.052.041.012.074a.091.091,0,0,1-.11.007c-.021-.023-.007-.073.027-.1S960.951,1499.09,960.969,1499.117Z",
  transform: "translate(-676.254 -1243.226)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path237",
  d: "M1497.807,694.776c-.029.027-.054.039-.082-.009s.008-.051.029-.07.056-.039.085.007S1497.832,694.757,1497.807,694.776Z",
  transform: "translate(-1201.756 -455.828)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path239",
  d: "M1352.857,1043.017c.011.016.031.033.018.053s-.044.014-.069.012a.061.061,0,0,1-.051-.049.2.2,0,0,1,0-.073.387.387,0,0,1,.07.021C1352.843,1042.987,1352.849,1043,1352.857,1043.017Z",
  transform: "translate(-1059.86 -796.75)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path241",
  d: "M1897.277,736.733c.011.016.031.033.018.053s-.044.014-.069.012a.063.063,0,0,1-.051-.049.2.2,0,0,1,0-.073.393.393,0,0,1,.071.021C1897.262,736.7,1897.268,736.721,1897.277,736.733Z",
  transform: "translate(-1592.769 -496.942)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path243",
  d: "M1989.537,711.352c.011.016.03.033.017.053s-.044.014-.069.012a.062.062,0,0,1-.051-.05.192.192,0,0,1,0-.072.384.384,0,0,1,.071.021C1989.521,711.322,1989.529,711.339,1989.537,711.352Z",
  transform: "translate(-1683.078 -472.098)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path245",
  d: "M1940.434,833.086c-.024.022-.041.028-.065,0s-.016-.066-.012-.1c.034.005.069,0,.09.043S1940.463,833.077,1940.434,833.086Z",
  transform: "translate(-1635.034 -591.216)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path247",
  d: "M1869.311,977.143a.023.023,0,0,1-.009.007l-.011,0-.011,0a.026.026,0,0,1-.009-.007.107.107,0,0,1-.012-.039c.042-.01.016-.069.057-.081.014,0,.028-.019.039-.016s.006.024,0,.035C1869.354,977.079,1869.36,977.125,1869.311,977.143Z",
  transform: "translate(-1565.446 -732.192)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path249",
  d: "M720.4,1513.926a.063.063,0,0,1,.047-.005.064.064,0,0,1,.037.029.092.092,0,0,1-.006.072c-.009.017-.08-.024-.1-.055A.029.029,0,0,1,720.4,1513.926Z",
  transform: "translate(-440.853 -1257.751)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path251",
  d: "M1567.836,778.237c.031-.014.039.007.051.022a.064.064,0,0,1,.013.021.058.058,0,0,1,0,.024.063.063,0,0,1-.005.024.062.062,0,0,1-.014.02.059.059,0,0,1-.036,0,.062.062,0,0,1-.03-.021.085.085,0,0,1,.018-.09Z",
  transform: "translate(-1270.373 -537.62)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path253",
  d: "M1772.227,584.366c.012.015.027.031.008.051a.08.08,0,0,1-.049.01.079.079,0,0,1-.046-.021c-.02-.023,0-.035.014-.048S1772.206,584.32,1772.227,584.366Z",
  transform: "translate(-1470.371 -347.824)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path255",
  d: "M940.78,1153.458c.012.015.027.031.008.052a.082.082,0,0,1-.049.01.081.081,0,0,1-.046-.021c-.02-.023,0-.035.014-.048S940.759,1153.414,940.78,1153.458Z",
  transform: "translate(-656.504 -904.884)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path257",
  d: "M1469.033,728.88c.025-.018.039,0,.049.015s.039.039.006.063a.048.048,0,0,1-.038.013.048.048,0,0,1-.019-.006.048.048,0,0,1-.015-.014.046.046,0,0,1-.008-.019.047.047,0,0,1,0-.02.046.046,0,0,1,.009-.018.05.05,0,0,1,.016-.013Z",
  transform: "translate(-1173.656 -489.303)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path259",
  d: "M1239.769,1480.619c.013.018.025.035,0,.052a.06.06,0,0,1-.04.01.059.059,0,0,1-.037-.019.062.062,0,0,1,0-.036.059.059,0,0,1,.021-.03C1239.747,1480.572,1239.755,1480.6,1239.769,1480.619Z",
  transform: "translate(-949.186 -1225.124)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path261",
  d: "M930.609,1550.522c.017.019.029.044,0,.057a.136.136,0,0,1-.072,0c-.009,0,.016-.072.029-.077S930.589,1550.493,930.609,1550.522Z",
  transform: "translate(-646.564 -1293.553)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path263",
  d: "M1782.284,556.708c.02,0,.051,0,.057.012a.061.061,0,0,1,.005.041.062.062,0,0,1-.021.035.024.024,0,0,1-.009.007l-.011,0-.011,0a.023.023,0,0,1-.009-.007C1782.26,556.767,1782.284,556.737,1782.284,556.708Z",
  transform: "translate(-1480.299 -320.779)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path265",
  d: "M961.165,1529.9c-.019.006-.033.007-.041-.011s-.013-.061.012-.075.026.025.039.039S961.176,1529.885,961.165,1529.9Z",
  transform: "translate(-676.503 -1273.306)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path267",
  d: "M2147.915,792.045a.231.231,0,0,1,.02.044c0,.007-.009.016-.015.023a.025.025,0,0,1-.009.007l-.011,0-.011,0a.023.023,0,0,1-.009-.007c-.025-.027,0-.056,0-.085Z",
  transform: "translate(-1838.164 -551.123)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path269",
  d: "M1056.184,1469.542a.02.02,0,0,1,0,.009.019.019,0,0,1,0,.01.02.02,0,0,1-.006.008.017.017,0,0,1-.009,0c-.02.007-.034.046-.057.015a.057.057,0,0,1,0-.029.06.06,0,0,1,.012-.026C1056.137,1469.526,1056.164,1469.539,1056.184,1469.542Z",
  transform: "translate(-769.491 -1214.302)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path271",
  d: "M912.936,1217.628l.009,0a.017.017,0,0,1,.01,0,.019.019,0,0,1,.008.006.018.018,0,0,1,0,.009c.007.019.046.034.016.057a.055.055,0,0,1-.056-.01C912.92,1217.675,912.934,1217.649,912.936,1217.628Z",
  transform: "translate(-629.332 -967.721)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path273",
  d: "M1528.475,748.488c.027.01.063,0,.079.031a.078.078,0,0,1,0,.028c-.027-.009-.062,0-.077-.031C1528.472,748.509,1528.475,748.5,1528.475,748.488Z",
  transform: "translate(-1231.866 -508.504)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path275",
  d: "M1041.159,1547.19c.027.01.063,0,.079.032a.081.081,0,0,1,0,.028c-.027-.009-.063,0-.077-.031C1041.156,1547.21,1041.16,1547.2,1041.159,1547.19Z",
  transform: "translate(-754.853 -1290.319)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path277",
  d: "M1565.114,690.839a.031.031,0,0,1,0,.021.03.03,0,0,1-.013.017c-.024.016-.039,0-.048-.014a.026.026,0,0,1,0-.022.026.026,0,0,1,.014-.017C1565.089,690.81,1565.1,690.823,1565.114,690.839Z",
  transform: "translate(-1267.668 -452.054)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path279",
  d: "M846.885,1387.123c.016.02.009.036-.008.039-.033.007.008.081-.056.059-.027-.009-.059-.008-.061-.045s.029-.032.044-.048S846.86,1387.133,846.885,1387.123Z",
  transform: "translate(-564.565 -1133.631)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path281",
  d: "M814.91,1405.077c.011.016.031.033.018.053s-.044.014-.069.011a.061.061,0,0,1-.033-.017.062.062,0,0,1-.018-.033.2.2,0,0,1,.005-.073.426.426,0,0,1,.07.021A.141.141,0,0,1,814.91,1405.077Z",
  transform: "translate(-533.287 -1151.155)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path283",
  d: "M837.257,1503.8c.031-.014.039.007.051.022a.059.059,0,0,1,.013.021.062.062,0,0,1,0,.048.059.059,0,0,1-.014.02.058.058,0,0,1-.066-.021.086.086,0,0,1,.018-.09Z",
  transform: "translate(-555.24 -1247.847)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path285",
  d: "M797.857,1429.88c.027.011.063,0,.079.031a.087.087,0,0,1,0,.028c-.027-.009-.062,0-.077-.031A.079.079,0,0,1,797.857,1429.88Z",
  transform: "translate(-516.696 -1175.489)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path287",
  d: "M834.486,1372.243a.028.028,0,0,1-.011.039c-.024.017-.039.005-.048-.014a.027.027,0,0,1,0-.01.026.026,0,0,1,0-.011.027.027,0,0,1,.005-.01l.009-.007C834.461,1372.213,834.474,1372.226,834.486,1372.243Z",
  transform: "translate(-552.488 -1119.05)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path289",
  d: "M1361.411,592.269c0,.019,0,.048-.013.055a.057.057,0,0,1-.056-.009c-.017-.031.022-.034.036-.049S1361.4,592.251,1361.411,592.269Z",
  transform: "translate(-1068.262 -355.574)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path291",
  d: "M1376.867,508.118c.012.017.02.033,0,.05l-.009.006h-.011l-.01,0a.027.027,0,0,1-.008-.007c-.015-.016-.021-.033,0-.05a.029.029,0,0,1,.021-.006.029.029,0,0,1,.019.009Z",
  transform: "translate(-1083.409 -273.207)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path293",
  d: "M796.323,1512.4a.029.029,0,0,1,0,.021.029.029,0,0,1-.013.017c-.024.016-.039,0-.048-.014a.027.027,0,0,1,0-.01.027.027,0,0,1,0-.011.027.027,0,0,1,.005-.01l.009-.007C796.3,1512.367,796.311,1512.38,796.323,1512.4Z",
  transform: "translate(-515.133 -1256.24)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path295",
  d: "M1873.986,661.436c-.024.019-.039.006-.049-.013a.029.029,0,0,1,0-.01.025.025,0,0,1,0-.011.026.026,0,0,1,.005-.01l.009-.007c.024-.016.039,0,.048.014a.025.025,0,0,1,0,.01.023.023,0,0,1,0,.011.027.027,0,0,1-.005.01.027.027,0,0,1-.009.006Z",
  transform: "translate(-1570.02 -423.234)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path297",
  d: "M1942.083,921.594c-.017.014-.035.02-.039,0s.026-.027.039-.041.029-.016.033,0S1942.088,921.581,1942.083,921.594Z",
  transform: "translate(-1636.691 -677.902)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path299",
  d: "M1150.113,739.015a.475.475,0,0,0-.062-.035c-.027-.011-.008-.023,0-.03s.035-.02.049,0A.435.435,0,0,1,1150.113,739.015Z",
  transform: "translate(-861.43 -499.155)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path301",
  d: "M1459.339,621.834c.011.017.023.035,0,.049l-.027.008,0-.068Z",
  transform: "translate(-1164.164 -384.518)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path303",
  d: "M1522.876,509.7l-.006-.039c.009,0,.022,0,.026.011a.147.147,0,0,1,.01.039Z",
  transform: "translate(-1226.38 -274.724)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path305",
  d: "M1552.307,793.013c.01.012.015.025,0,.033s-.017-.008-.023-.014-.015-.025,0-.033S1552.3,793.008,1552.307,793.013Z",
  transform: "translate(-1255.163 -552.074)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path307",
  d: "M1566.1,798.8c0,.021-.016.026-.028.033s-.019-.005-.02-.01.015-.024.027-.031S1566.1,798.8,1566.1,798.8Z",
  transform: "translate(-1268.653 -557.743)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path309",
  d: "M1919.573,867.253c-.012.01-.025.015-.033,0a.054.054,0,0,1,.014-.023c.006-.007.025-.015.033,0S1919.578,867.244,1919.573,867.253Z",
  transform: "translate(-1614.663 -624.726)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path311",
  d: "M2004.461,879.552l.005.039c-.009,0-.022,0-.026-.011a.153.153,0,0,1-.01-.039Z",
  transform: "translate(-1697.758 -636.786)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path313",
  d: "M968.682,1531.75a.183.183,0,0,1,.035.029c.005.006,0,.018,0,.028a.15.15,0,0,1-.035-.023C968.68,1531.778,968.683,1531.767,968.682,1531.75Z",
  transform: "translate(-683.909 -1275.205)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path315",
  d: "M1394.359,651.254v.026a.162.162,0,0,1-.035-.024c0-.005,0-.018,0-.028a.039.039,0,0,1,.035.026Z",
  transform: "translate(-1100.55 -413.301)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path317",
  d: "M1482.523,558.691c0,.021-.016.025-.028.033s-.019-.005-.02-.01.015-.024.027-.032S1482.516,558.688,1482.523,558.691Z",
  transform: "translate(-1186.838 -322.711)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path319",
  d: "M1480.695,726.535c0,.021-.016.025-.028.032a.023.023,0,0,1-.02-.009c0-.02.015-.024.027-.032S1480.688,726.532,1480.695,726.535Z",
  transform: "translate(-1185.049 -487.006)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path321",
  d: "M1198.984,641.262c.032.032.044.06-.007.1s-.059-.007-.082-.031-.046-.062.005-.1S1198.961,641.235,1198.984,641.262Z",
  transform: "translate(-909.228 -403.499)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path323",
  d: "M1117.432,955.65c.018-.014.039-.036.06-.022s.018.05.016.077a.071.071,0,0,1-.054.061.238.238,0,0,1-.084,0,.462.462,0,0,1,.021-.082C1117.4,955.668,1117.418,955.66,1117.432,955.65Z",
  transform: "translate(-829.454 -711.259)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path325",
  d: "M1239.362,675c-.022-.028-.005-.044.015-.057s.041-.047.071-.01a.053.053,0,0,1,.014.02.055.055,0,0,1,0,.023.055.055,0,0,1-.067.052.054.054,0,0,1-.037-.028Z",
  transform: "translate(-948.856 -436.492)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path327",
  d: "M981.873,1595.2c.011-.031-.006-.072.033-.093a.1.1,0,0,1,.033,0c-.01.031.005.072-.033.092a.093.093,0,0,1-.033,0Z",
  transform: "translate(-696.821 -1337.225)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path329",
  d: "M1236.192,664.342c.024,0,.03.017.038.031s0,.022-.01.023c-.022.005-.029-.016-.039-.03S1236.189,664.35,1236.192,664.342Z",
  transform: "translate(-945.753 -426.137)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path331",
  d: "M1467.033,439.761c.031-.014.039.007.051.022a.068.068,0,0,1,.013.021.061.061,0,0,1,0,.024.063.063,0,0,1-.006.024.062.062,0,0,1-.015.02.058.058,0,0,1-.036,0,.059.059,0,0,1-.03-.021.09.09,0,0,1,0-.048A.086.086,0,0,1,1467.033,439.761Z",
  transform: "translate(-1171.701 -206.301)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path333",
  d: "M1147.3,970.069c.025-.019.039,0,.049.015s.039.039.006.062a.05.05,0,0,1-.017.01.048.048,0,0,1-.02,0,.048.048,0,0,1-.019-.006.047.047,0,0,1-.015-.014.051.051,0,0,1-.008-.019.049.049,0,0,1,0-.02.053.053,0,0,1,.009-.018.051.051,0,0,1,.015-.013Z",
  transform: "translate(-858.722 -725.392)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path335",
  d: "M1644.547,531.51c.026.011.063,0,.077.032a.079.079,0,0,1,0,.028c-.027-.009-.063,0-.077-.031a.066.066,0,0,1,0-.029Z",
  transform: "translate(-1345.482 -296.114)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path337",
  d: "M1267.375,581.93c0,.021-.016.026-.028.033s-.019-.005-.02-.01.015-.024.027-.031S1267.368,581.927,1267.375,581.93Z",
  transform: "translate(-976.239 -345.46)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path339",
  d: "M1954.446,803.274l0,.023s-.013,0-.014,0a.116.116,0,0,1,0-.023Z",
  transform: "translate(-1648.815 -562.129)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path341",
  d: "M1571.057,850.842l0,.015-.021-.012s0-.009,0-.014Z",
  transform: "translate(-1273.525 -608.684)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path343",
  d: "M1915.218,815.958a.059.059,0,0,1,0,.014.043.043,0,0,1-.024,0c-.013-.007-.011-.016,0-.018S1915.21,815.956,1915.218,815.958Z",
  transform: "translate(-1610.398 -574.542)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path345",
  d: "M1913.607,815.571c-.008,0-.021,0-.022-.007s0-.019.012-.016a.116.116,0,0,1,.022.015Z",
  transform: "translate(-1608.833 -574.145)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path347",
  d: "M1562.483,607.814l-.023,0c0-.005,0-.013,0-.014a.093.093,0,0,1,.023,0Z",
  transform: "translate(-1265.133 -370.79)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path349",
  d: "M1444.653,613.916l0,.015a.094.094,0,0,1-.021-.012.036.036,0,0,1,0-.014Z",
  transform: "translate(-1149.794 -376.768)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path351",
  d: "M756.4,1467.018s-2.268-19.872,19.52-20.464l1.856-.193,7.836,6.9s-2.749,3.426-12.3,4.394c-5.842.592-8.065,3.888-7.664,9.354Z",
  transform: "translate(-476.051 -1191.621)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "path353",
  d: "M752.436,1463.075a.087.087,0,0,1-.087-.077,21.278,21.278,0,0,1,.18-4.94,20.847,20.847,0,0,1,1.234-4.673,16.728,16.728,0,0,1,2.9-4.814c3.373-3.885,8.518-5.949,15.292-6.134l1.852-.193a.09.09,0,0,1,.036,0,.094.094,0,0,1,.031.018l7.836,6.9a.088.088,0,0,1,.029.058.087.087,0,0,1-.019.062,8.483,8.483,0,0,1-2.6,1.856,27.116,27.116,0,0,1-9.765,2.569c-5.521.56-8,3.589-7.587,9.263a.086.086,0,0,1,0,.035.087.087,0,0,1-.019.03.09.09,0,0,1-.029.021.087.087,0,0,1-.035.007Zm21.345-20.654-1.817.189h-.007c-6.723.183-11.826,2.226-15.167,6.073a18.485,18.485,0,0,0-4.089,9.4,21.589,21.589,0,0,0-.188,4.823l9.072-.005c-.39-5.727,2.145-8.787,7.749-9.356a26.991,26.991,0,0,0,9.688-2.543,9.2,9.2,0,0,0,2.5-1.756Z",
  transform: "translate(-472.085 -1187.591)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path355",
  d: "M1240.543,2008.464a.06.06,0,0,1-.036-.012,3.569,3.569,0,0,1-.867-.985.059.059,0,0,1-.006-.044.06.06,0,0,1,.027-.035.058.058,0,0,1,.079.019,3.456,3.456,0,0,0,.839.952.057.057,0,0,1,.015.017.058.058,0,0,1,.007.021.064.064,0,0,1,0,.023.059.059,0,0,1-.057.043Z",
  transform: "translate(-949.131 -1740.779)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path357",
  d: "M1243.409,2048.581a.057.057,0,0,1-.034-.011l-.481-.344a.057.057,0,0,1-.022-.037.059.059,0,0,1,.01-.042.06.06,0,0,1,.036-.023.059.059,0,0,1,.042.008l.481.344a.058.058,0,0,1,.024.038.057.057,0,0,1-.01.043.059.059,0,0,1-.021.018A.058.058,0,0,1,1243.409,2048.581Z",
  transform: "translate(-952.302 -1780.66)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path359",
  d: "M1015.717,1742.232h-.014a1.6,1.6,0,0,1-1.158-1.167.056.056,0,0,1,0-.023.062.062,0,0,1,.008-.022.058.058,0,0,1,.016-.017.054.054,0,0,1,.021-.009.056.056,0,0,1,.023,0,.06.06,0,0,1,.022.009.059.059,0,0,1,.025.038,1.485,1.485,0,0,0,1.072,1.083.058.058,0,0,1,.039.022.059.059,0,0,1-.053.094Z",
  transform: "translate(-728.801 -1480.023)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path361",
  d: "M1076.218,2402.486h-.79a.059.059,0,0,1-.058-.058.059.059,0,0,1,.017-.041.058.058,0,0,1,.041-.017h.79a.058.058,0,0,1,.058.058.058.058,0,0,1-.058.058Z",
  transform: "translate(-788.342 -2127.417)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path363",
  d: "M804.525,2376.486h-.55a.057.057,0,0,1-.041-.017.057.057,0,0,1-.017-.041.058.058,0,0,1,.017-.041.057.057,0,0,1,.041-.017h.55a.058.058,0,0,1,.041.017.058.058,0,0,1,.017.041.057.057,0,0,1-.017.041A.057.057,0,0,1,804.525,2376.486Z",
  transform: "translate(-522.628 -2101.967)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path365",
  d: "M839.878,2355.366h-.137a.058.058,0,0,1-.058-.058.058.058,0,0,1,.058-.058h.137a.058.058,0,0,1,.041.1.058.058,0,0,1-.041.017Z",
  transform: "translate(-557.638 -2081.294)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path367",
  d: "M1923.828,1681.6l-2.9-3.027a3.115,3.115,0,0,0,.708,4.236S1923.439,1681.878,1923.828,1681.6Z",
  transform: "translate(-1615.49 -1418.921)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path369",
  d: "M1918.932,1680.2a.058.058,0,0,1-.039-.013,3.115,3.115,0,0,1-1.243-2.9,3.476,3.476,0,0,1,.525-1.413.056.056,0,0,1,.043-.025.056.056,0,0,1,.025,0,.053.053,0,0,1,.021.014l2.9,3.028a.056.056,0,0,1,.013.021.064.064,0,0,1,0,.025.062.062,0,0,1-.008.023.058.058,0,0,1-.017.018c-.387.28-2.126,1.175-2.2,1.213a.062.062,0,0,1-.027.006Zm-.7-4.2a3.5,3.5,0,0,0-.464,1.3,2.985,2.985,0,0,0,1.174,2.768c.24-.124,1.66-.861,2.094-1.148Z",
  transform: "translate(-1612.786 -1416.26)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path371",
  d: "M1993.561,1809.341a.361.361,0,1,0-.361-.361A.361.361,0,0,0,1993.561,1809.341Z",
  transform: "translate(-1686.766 -1546.221)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path373",
  d: "M1990.854,1806.676a.419.419,0,1,1,.3-.123.42.42,0,0,1-.3.123Zm0-.722a.3.3,0,1,0,.214.089.3.3,0,0,0-.214-.089Z",
  transform: "translate(-1684.059 -1543.497)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path375",
  d: "M1759.853,1426.578a.306.306,0,0,1-.114-.017.054.054,0,0,1-.016-.01l-8.179-7.148a.059.059,0,0,1-.017-.027.061.061,0,0,1,0-.032.055.055,0,0,1,.017-.027.056.056,0,0,1,.029-.014l1.753-.275a.057.057,0,0,1,.045.012c.267.216,6.554,5.317,7.4,6.318a.53.53,0,0,1,.122.365.711.711,0,0,1-.282.485A1.228,1.228,0,0,1,1759.853,1426.578Zm-.062-.122c.043.011.3.05.747-.336a.6.6,0,0,0,.242-.4.416.416,0,0,0-.093-.283c-.819-.967-6.967-5.963-7.367-6.289l-1.6.252Z",
  transform: "translate(-1450.2 -1164.865)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path377",
  d: "M441.715,2203.64a16.975,16.975,0,0,0,2.749,0s-1.444,2.749,0,4.261a4.04,4.04,0,0,0-2.749,1.439A5.713,5.713,0,0,1,441.715,2203.64Z",
  transform: "translate(-167.31 -1932.889)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path379",
  d: "M437.708,2205.366h0a.082.082,0,0,1-.041-.012.083.083,0,0,1-.03-.03,6.322,6.322,0,0,1-.678-1.843,5.234,5.234,0,0,1,.68-3.949.086.086,0,0,1,.035-.03.087.087,0,0,1,.045-.009,17.2,17.2,0,0,0,2.731,0,.087.087,0,0,1,.089.127c-.014.027-1.4,2.712-.014,4.161a.087.087,0,0,1,.018.092.085.085,0,0,1-.029.038.086.086,0,0,1-.046.017,3.973,3.973,0,0,0-2.685,1.4.091.091,0,0,1-.03.026.093.093,0,0,1-.039.01Zm.045-5.7a5.066,5.066,0,0,0-.629,3.771,6.509,6.509,0,0,0,.594,1.679,4.04,4.04,0,0,1,2.563-1.346,3.083,3.083,0,0,1-.45-2.648,6.786,6.786,0,0,1,.479-1.441,17.652,17.652,0,0,1-2.556-.015Z",
  transform: "translate(-163.303 -1928.829)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path381",
  d: "M2243.51,2452.8a3.624,3.624,0,0,0,1.684,1.649,6.85,6.85,0,0,0,4.708-2.977,6.974,6.974,0,0,1-2.131-2.031A5.061,5.061,0,0,1,2243.51,2452.8Z",
  transform: "translate(-1931.783 -2173.492)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path383",
  d: "M2241.149,2450.462a.1.1,0,0,1-.028,0,3.661,3.661,0,0,1-1.734-1.694.084.084,0,0,1-.01-.042.089.089,0,0,1,.041-.071.084.084,0,0,1,.041-.013,4.532,4.532,0,0,0,3.28-1.726,5.54,5.54,0,0,0,.9-1.574.088.088,0,0,1,.028-.041.085.085,0,0,1,.046-.019.086.086,0,0,1,.084.043,6.94,6.94,0,0,0,2.1,2,.081.081,0,0,1,.025.023.085.085,0,0,1,.014.031.088.088,0,0,1-.01.066,6.362,6.362,0,0,1-2.987,2.508,7.054,7.054,0,0,1-1.785.511Zm-1.543-1.66a3.393,3.393,0,0,0,1.552,1.484,7.125,7.125,0,0,0,1.724-.5,6.21,6.21,0,0,0,2.856-2.363,7.09,7.09,0,0,1-1.993-1.861,5.888,5.888,0,0,1-.87,1.459,4.707,4.707,0,0,1-3.268,1.779Z",
  transform: "translate(-1927.739 -2169.419)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path385",
  d: "M393.806,932.3a8.99,8.99,0,0,0,3.093-1.409s.172,3.712,2.1,5.465a4.17,4.17,0,0,0-1.65,1.856A8.681,8.681,0,0,1,393.806,932.3Z",
  transform: "translate(-121.188 -687.048)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path387",
  d: "M393.32,934.276a.086.086,0,0,1-.047-.014,7.745,7.745,0,0,1-1.6-1.478,8.756,8.756,0,0,1-1.983-4.495.087.087,0,0,1,.069-.1,9,9,0,0,0,3.06-1.395.087.087,0,0,1,.137.067c0,.037.193,3.7,2.068,5.4a.087.087,0,0,1,.028.074.087.087,0,0,1-.043.066,4.114,4.114,0,0,0-1.611,1.811.086.086,0,0,1-.021.032.084.084,0,0,1-.033.02.081.081,0,0,1-.027,0Zm-3.441-5.931a8.585,8.585,0,0,0,1.929,4.322,8.143,8.143,0,0,0,1.474,1.389,4.217,4.217,0,0,1,1.547-1.738,7.135,7.135,0,0,1-1.712-3.354,12.563,12.563,0,0,1-.319-1.936,9.314,9.314,0,0,1-2.921,1.317Z",
  transform: "translate(-117.162 -683.029)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path389",
  d: "M390.692,1983.174a.2.2,0,1,0-.233-.2A.219.219,0,0,0,390.692,1983.174Z",
  transform: "translate(-117.912 -1716.689)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path391",
  d: "M388.007,1980.55a.262.262,0,1,1,.29-.26A.276.276,0,0,1,388.007,1980.55Zm0-.4a.147.147,0,1,0,.174.144A.162.162,0,0,0,388.007,1980.146Z",
  transform: "translate(-115.227 -1714.007)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path393",
  d: "M2279.26,2494.063a2.159,2.159,0,0,0,1.048.928,6.232,6.232,0,0,0,3.866-2.372,4.813,4.813,0,0,1-1.357-1.34S2281.344,2493.93,2279.26,2494.063Z",
  transform: "translate(-1966.777 -2214.448)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path395",
  d: "M2277.538,2492.356a.06.06,0,0,1-.018,0,2.211,2.211,0,0,1-1.083-.956.06.06,0,0,1-.007-.028.062.062,0,0,1,.007-.028.063.063,0,0,1,.02-.021.067.067,0,0,1,.027-.009c2.029-.129,3.5-2.727,3.51-2.754a.057.057,0,0,1,.021-.021.056.056,0,0,1,.029-.008.054.054,0,0,1,.029.007.057.057,0,0,1,.021.022,4.785,4.785,0,0,0,1.339,1.32.067.067,0,0,1,.017.017.061.061,0,0,1,.009.022.054.054,0,0,1,0,.023.05.05,0,0,1-.009.021,6.36,6.36,0,0,1-3.9,2.4Zm-.95-.936a2.044,2.044,0,0,0,.955.819,6.224,6.224,0,0,0,3.779-2.3,4.886,4.886,0,0,1-1.276-1.242,8.133,8.133,0,0,1-.955,1.268A4.214,4.214,0,0,1,2276.588,2491.419Z",
  transform: "translate(-1964.007 -2211.754)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path397",
  d: "M464.44,2230.4a10.192,10.192,0,0,0,1.787,0s-.931,2.4.077,3.454a2.616,2.616,0,0,0-1.968.911S463.2,2232.328,464.44,2230.4Z",
  transform: "translate(-189.76 -1959.083)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path399",
  d: "M461.7,2232.108h-.005a.059.059,0,0,1-.028-.01.057.057,0,0,1-.019-.023,6.014,6.014,0,0,1-.42-1.475,4.246,4.246,0,0,1,.527-2.945.059.059,0,0,1,.023-.021.06.06,0,0,1,.031-.006,10.2,10.2,0,0,0,1.774,0,.059.059,0,0,1,.053.021.059.059,0,0,1,.009.056c-.009.024-.907,2.375.065,3.393a.057.057,0,0,1,.015.03.058.058,0,0,1,0,.033.058.058,0,0,1-.053.035h0a2.573,2.573,0,0,0-1.92.886.058.058,0,0,1-.021.019.059.059,0,0,1-.027.007Zm.133-4.361a4.871,4.871,0,0,0-.119,4.189,2.619,2.619,0,0,1,1.83-.85c-.8-1-.2-2.89-.041-3.331A10.244,10.244,0,0,1,461.831,2227.747Z",
  transform: "translate(-187.121 -1956.37)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path401",
  d: "M426.317,970.957a8.363,8.363,0,0,0,2.028-1.048s.508,3.387,1.77,4.536a2.822,2.822,0,0,0-1.134,1.237A7.58,7.58,0,0,1,426.317,970.957Z",
  transform: "translate(-153.012 -725.244)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path403",
  d: "M426.3,973.043a.058.058,0,0,1-.036-.012,7.782,7.782,0,0,1-1.233-1.291,6.968,6.968,0,0,1-1.453-3.474.059.059,0,0,1,.009-.037.058.058,0,0,1,.03-.024,8.367,8.367,0,0,0,2.01-1.04.058.058,0,0,1,.056-.006.059.059,0,0,1,.023.018.06.06,0,0,1,.012.027c.005.034.52,3.38,1.751,4.5a.058.058,0,0,1,.009.075.056.056,0,0,1-.02.019,2.783,2.783,0,0,0-1.108,1.207.057.057,0,0,1-.015.022.056.056,0,0,1-.024.013Zm-2.6-4.743a7.551,7.551,0,0,0,2.577,4.591,2.839,2.839,0,0,1,1.063-1.153c-1.121-1.1-1.626-3.872-1.718-4.425a8.611,8.611,0,0,1-1.922.988Z",
  transform: "translate(-150.33 -722.546)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path405",
  d: "M1785.729,877.366s3.248.221,4.073,1.132.159,11.014-8.813,17.071l-8.87-7.2Z",
  transform: "translate(-1470.36 -634.657)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "path407",
  d: "M1959.294,1379.12h-.01a.058.058,0,0,1-.047-.067l.035-.193c.2-1.119.43-2.387.541-3.48a.06.06,0,0,1,.021-.039.058.058,0,0,1,.095.051c-.113,1.1-.341,2.369-.541,3.49l-.034.193a.058.058,0,0,1-.021.033.056.056,0,0,1-.038.012Z",
  transform: "translate(-1653.52 -1122.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path409",
  d: "M2069.772,1325.393h-.008a.057.057,0,0,1-.038-.022.058.058,0,0,1-.011-.043l.912-6.773a.06.06,0,0,1,.022-.039.058.058,0,0,1,.043-.011.057.057,0,0,1,.039.022.059.059,0,0,1,.012.043l-.911,6.773a.057.057,0,0,1-.059.05Z",
  transform: "translate(-1761.662 -1066.468)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path411",
  d: "M2207.533,1346.594l-.017,0a.062.062,0,0,1-.02-.011.055.055,0,0,1-.014-.018.057.057,0,0,1-.007-.022.055.055,0,0,1,0-.023,72.95,72.95,0,0,0,1.492-8.117.066.066,0,0,1,.007-.021.064.064,0,0,1,.015-.017.059.059,0,0,1,.021-.01.063.063,0,0,1,.023,0,.061.061,0,0,1,.021.007.058.058,0,0,1,.017.015.059.059,0,0,1,.011.043,73.036,73.036,0,0,1-1.5,8.136.058.058,0,0,1-.056.041Z",
  transform: "translate(-1896.51 -1085.895)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path413",
  d: "M2382.593,1263.878h-.007a.058.058,0,0,1-.039-.021.058.058,0,0,1-.012-.043,27.327,27.327,0,0,0-.271-6.173.059.059,0,0,1,.048-.068.059.059,0,0,1,.068.049,27.15,27.15,0,0,1,.273,6.2.058.058,0,0,1-.061.051Z",
  transform: "translate(-2067.603 -1006.825)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path415",
  d: "M2459.631,1120.923a.058.058,0,0,1-.057-.054,18.073,18.073,0,0,0-1.135-5.475.056.056,0,0,1-.006-.022.062.062,0,0,1,0-.023.059.059,0,0,1,.012-.02.061.061,0,0,1,.019-.014.065.065,0,0,1,.023-.005.058.058,0,0,1,.023,0,.058.058,0,0,1,.019.013.06.06,0,0,1,.013.02,18.15,18.15,0,0,1,1.145,5.514.061.061,0,0,1-.014.042.059.059,0,0,1-.04.02Z",
  transform: "translate(-2142.161 -867.57)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path417",
  d: "M2479.063,887.4a.058.058,0,0,1-.037-.013.056.056,0,0,1-.02-.033,11.952,11.952,0,0,0-2.664-5.135.058.058,0,0,1-.015-.041.058.058,0,0,1,.1-.039,12.075,12.075,0,0,1,2.693,5.191.05.05,0,0,1,0,.023.062.062,0,0,1-.008.021.061.061,0,0,1-.016.016.056.056,0,0,1-.021.009l-.012,0Z",
  transform: "translate(-2159.678 -639.315)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path419",
  d: "M2065.184,1632.515a34.941,34.941,0,0,1-3.62-.218.057.057,0,0,1-.022-.007.061.061,0,0,1-.017-.015.064.064,0,0,1-.01-.02.058.058,0,0,1,.005-.044.061.061,0,0,1,.035-.028.06.06,0,0,1,.023,0,28.365,28.365,0,0,0,5.261.136.058.058,0,0,1,.065.051.059.059,0,0,1-.012.043.058.058,0,0,1-.039.022A14.949,14.949,0,0,1,2065.184,1632.515Z",
  transform: "translate(-1753.634 -1373.513)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path421",
  d: "M1947.028,1515.452a.058.058,0,0,1-.058-.058.058.058,0,0,1,.058-.058,86.084,86.084,0,0,0,10.067-.628.058.058,0,0,1,.044.01.059.059,0,0,1,.024.038.059.059,0,0,1-.01.044.058.058,0,0,1-.038.024,86.264,86.264,0,0,1-10.086.629Z",
  transform: "translate(-1641.513 -1258.523)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path423",
  d: "M1864.618,1351.506a.058.058,0,1,1,0-.116c.087,0,8.779-.459,13.962-1.991a.056.056,0,0,1,.042.007.058.058,0,0,1,.026.033.058.058,0,0,1-.036.071c-5.2,1.536-13.9,1.991-13.989,2Z",
  transform: "translate(-1560.844 -1096.709)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path425",
  d: "M2362.745,1222.468a.057.057,0,0,1-.038-.014.056.056,0,0,1-.02-.035.057.057,0,0,1,.008-.039.058.058,0,0,1,.032-.025c.029-.009,2.89-.9,4.544-1.51a.058.058,0,0,1,.041.005.06.06,0,0,1,.027.032.058.058,0,0,1-.029.072c-1.656.613-4.521,1.5-4.55,1.513l-.015,0Z",
  transform: "translate(-2048.44 -970.872)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path427",
  d: "M2452.126,1080.46a.058.058,0,0,1-.021-.112c.025-.01,2.52-1.005,3.364-1.436a.057.057,0,0,1,.075.027.058.058,0,0,1,0,.043.059.059,0,0,1-.027.034c-.851.433-3.35,1.431-3.375,1.441a.057.057,0,0,1-.02,0Z",
  transform: "translate(-2135.932 -831.937)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path429",
  d: "M2476.348,941.865a.059.059,0,0,1-.037-.013.058.058,0,0,1,.017-.1,18.983,18.983,0,0,0,2.856-1.343.058.058,0,0,1,.079.021.058.058,0,0,1-.02.079,19.261,19.261,0,0,1-2.876,1.353.054.054,0,0,1-.019,0Z",
  transform: "translate(-2159.641 -696.361)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path431",
  d: "M1320.163,1282.3l-.732-.858-16.989,3.522-.464,1.245-1,.279s3.8,2.056,10.455-.11c4.65-1.513,5.787-2.745,8.048-3.768-.235-.089-.333.007-.576-.028A9.909,9.909,0,0,0,1320.163,1282.3Z",
  transform: "translate(-1009.181 -1030.188)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path433",
  d: "M1000.593,872.722s-1.823-.972-9.262,3.138-13.884,2.172-18.884,1.234c0,0-1.083,2.4-1.649,3.952l1.8,1.2-2.165-.271s-.309,1.482-.412,2.085c0,0,8.439,3.189,14.434,1.894a69.438,69.438,0,0,0,10.774-3.536s2.749,1.2,4.889-2.189C1002.17,876.987,1002.125,873.682,1000.593,872.722Z",
  transform: "translate(-685.223 -630.013)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path435",
  d: "M977.247,882.19a29.974,29.974,0,0,1-6.306-.77,40.567,40.567,0,0,1-4.981-1.437.086.086,0,0,1-.055-.1c.1-.6.41-2.074.413-2.088a.087.087,0,0,1,.1-.069l1.8.226-1.5-.993a.087.087,0,0,1-.034-.045.089.089,0,0,1,0-.057c.562-1.538,1.641-3.935,1.652-3.959a.087.087,0,0,1,.1-.05c.51.1,1.026.2,1.572.309,4.722.955,10.6,2.143,17.253-1.534,7.4-4.087,9.269-3.18,9.345-3.139l.005,0a2.515,2.515,0,0,1,1.039,1.642,6.226,6.226,0,0,1-.088,2.742,10.78,10.78,0,0,1-1.4,3.244,4.653,4.653,0,0,1-3.31,2.4,3.526,3.526,0,0,1-1.66-.17,15.747,15.747,0,0,0-1.534.583,51.719,51.719,0,0,1-9.215,2.947A15.257,15.257,0,0,1,977.247,882.19Zm-11.158-2.344a41.377,41.377,0,0,0,4.892,1.4,23.682,23.682,0,0,0,9.425.461,51.485,51.485,0,0,0,9.186-2.938,14.725,14.725,0,0,1,1.585-.6.09.09,0,0,1,.056,0,3.328,3.328,0,0,0,1.605.168,4.581,4.581,0,0,0,3.176-2.323,8.361,8.361,0,0,0,1.46-5.854,2.35,2.35,0,0,0-.957-1.53,3.345,3.345,0,0,0-1.833.047,27.286,27.286,0,0,0-7.346,3.093c-6.711,3.708-12.622,2.513-17.372,1.553-.522-.105-1.016-.205-1.5-.3-.171.382-1.083,2.427-1.6,3.82l1.747,1.16a.087.087,0,0,1,0,.147.085.085,0,0,1-.056.012l-2.085-.261c-.062.3-.287,1.387-.382,1.932Z",
  transform: "translate(-681.19 -625.857)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path437",
  d: "M2151.412,1316.565a.058.058,0,0,1-.037-.013.06.06,0,0,1-.02-.035.058.058,0,0,1,.007-.039.059.059,0,0,1,.031-.026,9.882,9.882,0,0,1,1.476-.381.062.062,0,0,1,.023,0,.059.059,0,0,1,.021.009.058.058,0,0,1,.016.017.051.051,0,0,1,.008.021.053.053,0,0,1,0,.023.06.06,0,0,1-.026.037.061.061,0,0,1-.021.008,9.707,9.707,0,0,0-1.457.375.059.059,0,0,1-.02,0Z",
  transform: "translate(-1841.576 -1064.086)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path439",
  d: "M2140.655,869.051c-.48-.193-.619.039-.619.039,1.307.509,1.415,2.687,1.282,3.427-.785,4.361-2.957,5.789-4.024,6.229a4.266,4.266,0,0,1-2.177.153c-.088.027-.661.262-.827.342,4.671,1.541,7.024-3.3,7.415-5.877C2142.167,870.323,2141.134,869.245,2140.655,869.051Z",
  transform: "translate(-1824.872 -626.442)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path441",
  d: "M2133.449,876.824a5.6,5.6,0,0,1-1.758-.3.059.059,0,0,1-.039-.051.059.059,0,0,1,.008-.033.057.057,0,0,1,.025-.023c.169-.082.743-.317.836-.346a.06.06,0,0,1,.025,0l.029,0a4.175,4.175,0,0,0,2.118-.155c.934-.384,3.191-1.756,3.988-6.186.143-.791-.013-2.883-1.245-3.364a.057.057,0,0,1-.021-.014.061.061,0,0,1-.013-.021.057.057,0,0,1,0-.025.055.055,0,0,1,.008-.024c.007-.011.169-.275.689-.065a1.918,1.918,0,0,1,.911,1.121,6.485,6.485,0,0,1,.176,3.254,8.353,8.353,0,0,1-3.342,5.542A4.5,4.5,0,0,1,2133.449,876.824Zm-1.578-.365a4.608,4.608,0,0,0,3.908-.416,8.221,8.221,0,0,0,3.286-5.46c.434-2.861-.475-4.032-1.016-4.253a.552.552,0,0,0-.49-.032c1.29.591,1.359,2.757,1.233,3.456a10.08,10.08,0,0,1-1.918,4.611,5.485,5.485,0,0,1-2.14,1.662,4.286,4.286,0,0,1-2.177.16h-.016C2132.449,876.218,2132.093,876.363,2131.871,876.459Z",
  transform: "translate(-1822.291 -623.67)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path443",
  d: "M2454.8,871.736s2.629.309,3.248,1.047a.38.38,0,0,0,.055-.509C2458,872.143,2455.827,871.089,2454.8,871.736Z",
  transform: "translate(-2138.606 -628.942)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path445",
  d: "M2455.414,870.157h0a.056.056,0,0,1-.022-.006.057.057,0,0,1-.018-.015c-.6-.713-3.184-1.023-3.209-1.026a.058.058,0,0,1-.05-.045.055.055,0,0,1,0-.035.058.058,0,0,1,.022-.027,2.705,2.705,0,0,1,2.046-.029,4.493,4.493,0,0,1,1.334.58.43.43,0,0,1-.062.588.058.058,0,0,1-.04.016Zm-3.057-1.139c.6.084,2.464.387,3.057.994a.3.3,0,0,0,.01-.387C2455.318,869.507,2453.4,868.579,2452.356,869.018Z",
  transform: "translate(-2135.971 -626.259)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path447",
  d: "M2374.238,966.17a.06.06,0,0,1-.022,0,.061.061,0,0,1-.032-.032.061.061,0,0,1,0-.023.061.061,0,0,1,.005-.023,3.284,3.284,0,0,0,.14-2.076.058.058,0,0,1,.006-.044.058.058,0,0,1,.079-.021.057.057,0,0,1,.027.035,3.4,3.4,0,0,1-.146,2.15.058.058,0,0,1-.054.037Z",
  transform: "translate(-2059.69 -719.4)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path449",
  d: "M2351.83,999.29a.059.059,0,0,1-.046-.023.063.063,0,0,1-.011-.024.064.064,0,0,1,0-.026,2.049,2.049,0,0,0-.014-1.153.058.058,0,0,1,0-.023.057.057,0,0,1,.006-.023.058.058,0,0,1,.014-.018.06.06,0,0,1,.021-.011.058.058,0,0,1,.023,0,.057.057,0,0,1,.04.022.057.057,0,0,1,.01.021,2.162,2.162,0,0,1,.015,1.219.058.058,0,0,1-.056.042Z",
  transform: "translate(-2037.741 -752.726)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path451",
  d: "M1587.919,1429.515a2.963,2.963,0,0,1-1.17-.238.058.058,0,1,1,.046-.107,2.857,2.857,0,0,0,2.025.083.064.064,0,0,1,.022,0,.058.058,0,0,1,.022.006.054.054,0,0,1,.018.013.057.057,0,0,1,.011.02.053.053,0,0,1,0,.022.055.055,0,0,1-.006.022.054.054,0,0,1-.014.018.06.06,0,0,1-.019.012,2.943,2.943,0,0,1-.94.152Z",
  transform: "translate(-1288.875 -1174.789)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path453",
  d: "M1707.082,1160.283a.059.059,0,0,1-.057-.051,3.59,3.59,0,0,0-.544-1.477.058.058,0,0,1,.017-.08.057.057,0,0,1,.044-.008.058.058,0,0,1,.037.025,3.719,3.719,0,0,1,.562,1.525.057.057,0,0,1,0,.023.058.058,0,0,1-.027.035.054.054,0,0,1-.022.007Z",
  transform: "translate(-1406.099 -910.009)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path455",
  d: "M1749.2,1188.933a.057.057,0,0,1-.035-.012.056.056,0,0,1-.021-.03l-.1-.361a.057.057,0,0,1,.005-.044.059.059,0,0,1,.035-.028.058.058,0,0,1,.044.005.056.056,0,0,1,.027.035l.1.361a.058.058,0,0,1-.039.072Z",
  transform: "translate(-1447.763 -939.169)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path457",
  d: "M1071.81,1130.962a.058.058,0,0,1-.018,0,.057.057,0,0,1-.02-.011.054.054,0,0,1-.014-.018.059.059,0,0,1-.007-.022.061.061,0,0,1,0-.023l.322-.975a.058.058,0,0,1,.107-.008.057.057,0,0,1,0,.044l-.322.975a.058.058,0,0,1-.02.029.056.056,0,0,1-.033.011Z",
  transform: "translate(-784.798 -881.824)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path459",
  d: "M1101.155,1198.175h-.011a.057.057,0,0,1-.021-.009.057.057,0,0,1-.016-.016.061.061,0,0,1-.009-.021.055.055,0,0,1,0-.023l.05-.258a.059.059,0,0,1,.008-.022.061.061,0,0,1,.016-.017.058.058,0,0,1,.022-.01.061.061,0,0,1,.023,0,.058.058,0,0,1,.022.009.056.056,0,0,1,.016.017.059.059,0,0,1,.009.022.061.061,0,0,1,0,.023l-.05.258a.056.056,0,0,1-.02.033A.057.057,0,0,1,1101.155,1198.175Z",
  transform: "translate(-813.525 -948.315)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path461",
  d: "M2072.2,1679.452a.059.059,0,0,1-.039-.014l-.773-.669a.06.06,0,0,1-.02-.04.059.059,0,0,1,.1-.048l.773.669a.059.059,0,0,1,.014.018.058.058,0,0,1-.008.064.057.057,0,0,1-.02.015.06.06,0,0,1-.025.005Z",
  transform: "translate(-1763.277 -1419.015)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path463",
  d: "M1277.678,1035.4a.061.061,0,0,1-.028-.007l-.687-.379a.053.053,0,0,1-.017-.015.055.055,0,0,1-.011-.02.059.059,0,0,1,0-.023.056.056,0,0,1,.007-.021.058.058,0,0,1,.015-.017.057.057,0,0,1,.043-.012.06.06,0,0,1,.021.007l.687.379a.057.057,0,0,1-.028.109Z",
  transform: "translate(-985.643 -788.863)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path465",
  d: "M1397.592,934.9a.058.058,0,0,1-.033-.011.056.056,0,0,1-.021-.028l-.241-.619a.058.058,0,0,1,.108-.042l.241.619a.058.058,0,0,1-.033.075.057.057,0,0,1-.021.005Z",
  transform: "translate(-1103.459 -690.257)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path467",
  d: "M1317.962,961.581a.056.056,0,0,1-.025-.005.058.058,0,0,1-.02-.015l-.76-.925a.058.058,0,0,1,.008-.082.054.054,0,0,1,.02-.011.058.058,0,0,1,.023,0,.06.06,0,0,1,.022.007.054.054,0,0,1,.017.015l.76.924a.057.057,0,0,1,.013.03.055.055,0,0,1-.005.032.057.057,0,0,1-.021.024.057.057,0,0,1-.031.009Z",
  transform: "translate(-1025.004 -716.074)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path469",
  d: "M1480.65,927.5h-.012a.058.058,0,0,1-.021-.009.06.06,0,0,1-.016-.016.058.058,0,0,1-.008-.021.059.059,0,0,1,0-.023l.293-1.405a.061.061,0,0,1,.009-.021.059.059,0,0,1,.037-.024.059.059,0,0,1,.044.009.059.059,0,0,1,.016.016.062.062,0,0,1,.008.021.059.059,0,0,1,0,.023l-.293,1.405a.059.059,0,0,1-.057.045Z",
  transform: "translate(-1184.996 -682.246)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path471",
  d: "M1545.976,981.879a.058.058,0,0,1-.039-.016.058.058,0,0,1,0-.082l.735-.778a.056.056,0,0,1,.019-.013.057.057,0,0,1,.022-.005.058.058,0,0,1,.042.016.056.056,0,0,1,.013.018.058.058,0,0,1,.005.022.054.054,0,0,1,0,.022.057.057,0,0,1-.012.019l-.735.778a.063.063,0,0,1-.02.014.059.059,0,0,1-.023,0Z",
  transform: "translate(-1248.942 -736.085)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path473",
  d: "M1575.968,1070.835a.058.058,0,0,1-.06-.055.058.058,0,0,1,.055-.06l.756-.068a.057.057,0,0,1,.023,0,.053.053,0,0,1,.02.011.056.056,0,0,1,.014.018.057.057,0,0,1,.006.022.06.06,0,0,1,0,.023.055.055,0,0,1-.011.02.052.052,0,0,1-.018.014.055.055,0,0,1-.022.007l-.756.069Z",
  transform: "translate(-1278.296 -823.855)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path475",
  d: "M912.437,698.078a8.827,8.827,0,0,0-3.885-3.422,9.208,9.208,0,0,1-1.065,3.6s3.424,1.418,4.139,1.35Z",
  transform: "translate(-624.008 -455.81)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path477",
  d: "M907.639,695.768a23.021,23.021,0,0,1-4.12-1.357.087.087,0,0,1-.053-.089.088.088,0,0,1,.011-.035,9.191,9.191,0,0,0,1.054-3.561.086.086,0,0,1,.039-.067.087.087,0,0,1,.077-.01,8.964,8.964,0,0,1,3.931,3.459.086.086,0,0,1,.012.042.084.084,0,0,1-.01.043l-.812,1.529a.086.086,0,0,1-.028.031.087.087,0,0,1-.04.014Zm-3.966-1.483a20.313,20.313,0,0,0,3.958,1.309h0l.765-1.441a8.8,8.8,0,0,0-3.707-3.3A9.414,9.414,0,0,1,903.673,694.285Z",
  transform: "translate(-620.071 -451.883)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path479",
  d: "M1085.152,338.707a13.812,13.812,0,0,1-3.042,2.2,12.87,12.87,0,0,0,4.521,2.6l.906-1.707Z",
  transform: "translate(-794.939 -107.387)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path481",
  d: "M1082.613,339.56a.088.088,0,0,1-.024,0,13.1,13.1,0,0,1-4.556-2.622.087.087,0,0,1,.021-.142,13.844,13.844,0,0,0,3.021-2.183.085.085,0,0,1,.031-.019.086.086,0,0,1,.036-.005.091.091,0,0,1,.035.01.089.089,0,0,1,.028.023l2.383,3.095a.087.087,0,0,1,.008.094l-.906,1.707a.088.088,0,0,1-.077.046Zm-4.367-2.668a12.863,12.863,0,0,0,4.323,2.478l.846-1.6-2.29-2.974a14.05,14.05,0,0,1-2.879,2.09Z",
  transform: "translate(-790.921 -103.352)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path483",
  d: "M1132.124,361.453a11.021,11.021,0,0,1-2.434,1.757,10.318,10.318,0,0,0,3.7,2.223l.726-1.368Z",
  transform: "translate(-841.513 -129.653)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path485",
  d: "M1130.709,362.747l-.016,0a10.468,10.468,0,0,1-3.719-2.237.058.058,0,0,1,.015-.094,11.087,11.087,0,0,0,2.418-1.748.059.059,0,0,1,.021-.013.058.058,0,0,1,.066.019l1.987,2.614a.057.057,0,0,1,0,.062l-.726,1.368a.056.056,0,0,1-.021.023A.057.057,0,0,1,1130.709,362.747Zm-3.6-2.266a10.277,10.277,0,0,0,3.565,2.139l.686-1.294-1.925-2.532a11.1,11.1,0,0,1-2.324,1.688Z",
  transform: "translate(-838.837 -126.908)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path487",
  d: "M2651.7,2515.74a.058.058,0,0,1-.039-.016.069.069,0,0,1-.013-.019.06.06,0,0,1,0-.045.069.069,0,0,1,.013-.019,3.33,3.33,0,0,0,.889-2.692.058.058,0,0,1,0-.022.059.059,0,0,1,.01-.021.063.063,0,0,1,.017-.015.06.06,0,0,1,.022-.008.05.05,0,0,1,.022,0,.052.052,0,0,1,.021.01.064.064,0,0,1,.015.017.058.058,0,0,1,.007.022,3.447,3.447,0,0,1-.919,2.788.059.059,0,0,1-.021.014A.063.063,0,0,1,2651.7,2515.74Z",
  transform: "translate(-2331.284 -2235.594)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path489",
  d: "M2694.3,2618.069a.06.06,0,0,1-.033-.01.057.057,0,0,1-.023-.062.056.056,0,0,1,.018-.03,2,2,0,0,0,.6-1,.058.058,0,0,1,.026-.036.06.06,0,0,1,.044-.007.058.058,0,0,1,.043.07,2.114,2.114,0,0,1-.636,1.061.057.057,0,0,1-.038.015Z",
  transform: "translate(-2372.985 -2337.433)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path491",
  d: "M355.051,2453.185a.067.067,0,0,1-.02,0,2.752,2.752,0,0,1-1.695-1.892.058.058,0,0,1,.007-.044.058.058,0,0,1,.08-.019.057.057,0,0,1,.026.036,2.631,2.631,0,0,0,1.621,1.81.06.06,0,0,1,.03.026.058.058,0,0,1-.013.073A.058.058,0,0,1,355.051,2453.185Z",
  transform: "translate(-81.573 -2175.233)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path493",
  d: "M271.694,1072.808a.058.058,0,0,1-.034-.011,4.157,4.157,0,0,1-1.66-2.564.058.058,0,0,1,.046-.066.058.058,0,0,1,.068.043,4.044,4.044,0,0,0,1.613,2.492.057.057,0,0,1,.021.029.058.058,0,0,1,0,.036.057.057,0,0,1-.021.029.058.058,0,0,1-.034.011Z",
  transform: "translate(0 -823.382)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path495",
  d: "M279.608,1168.141h-.014a1.362,1.362,0,0,1-.941-.858.058.058,0,0,1,0-.044.057.057,0,0,1,.033-.03.054.054,0,0,1,.022,0,.057.057,0,0,1,.022.006.054.054,0,0,1,.018.014.057.057,0,0,1,.012.019,1.26,1.26,0,0,0,.861.782.058.058,0,0,1-.014.116Z",
  transform: "translate(-8.467 -918.369)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path497",
  d: "M1346,1514.657h0a6.715,6.715,0,0,1-1.036-.359l0,0,0,0a.014.014,0,0,1,0-.005.013.013,0,0,1,0-.005l0,0,0,0h.011a6.78,6.78,0,0,0,1.032.358l.005,0,0,0,0,.005a.02.02,0,0,1,0,.005.014.014,0,0,1-.014.011Z",
  transform: "translate(-1052.222 -1258.095)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path499",
  d: "M1431.9,1526.414h0l-.412-.07-.005,0,0,0,0-.005a.015.015,0,0,1,0-.006.015.015,0,0,1,.006-.009.016.016,0,0,1,.011,0l.412.07a.015.015,0,0,1,.009.006.016.016,0,0,1,0,.011.015.015,0,0,1-.005.009.014.014,0,0,1-.009,0Z",
  transform: "translate(-1136.916 -1269.885)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path501",
  d: "M1453.175,1544.69a2.76,2.76,0,0,1-.879-.144l-.005,0,0,0a.01.01,0,0,1,0-.005.011.011,0,0,1,0-.006l0,0,0,0h.011a2.736,2.736,0,0,0,1.281.111h.006l.005,0,0,0a.013.013,0,0,1,0,.005.014.014,0,0,1,0,.011.015.015,0,0,1-.01.006,2.742,2.742,0,0,1-.416.032Z",
  transform: "translate(-1157.289 -1287.703)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path503",
  d: "M1501.788,1534.159h-.67l0,0,0,0a.016.016,0,0,1,0-.005.018.018,0,0,1,0-.006l0,0,0,0h.67a.015.015,0,0,1,.014.015.015.015,0,0,1,0,.01.015.015,0,0,1-.01,0Z",
  transform: "translate(-1205.08 -1277.535)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path505",
  d: "M1595.442,1519.725h-.048a.015.015,0,0,1-.014-.015.015.015,0,0,1,.015-.014h0a2.734,2.734,0,0,0,.889-.133.017.017,0,0,1,.011,0,.015.015,0,0,1,.007.008.015.015,0,0,1,0,.011l0,0,0,0a2.761,2.761,0,0,1-.851.134Z",
  transform: "translate(-1297.357 -1263.276)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path507",
  d: "M1559.641,1540.826a.014.014,0,0,1-.01,0,.013.013,0,0,1,0-.01.013.013,0,0,1,0-.006l0,0,0,0h.005a12.774,12.774,0,0,0,1.6-.2h.006l.005,0,0,0,0,.005a.016.016,0,0,1,0,.011.015.015,0,0,1-.009.006,12.815,12.815,0,0,1-1.606.2Z",
  transform: "translate(-1262.359 -1283.862)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path509",
  d: "M1747.435,1503.222a.014.014,0,0,1-.009,0,.015.015,0,0,1-.005-.007.015.015,0,0,1,.009-.019l.627-.225h.011l0,0,0,0a.013.013,0,0,1,0,.006.011.011,0,0,1,0,.005l0,0,0,0-.627.226Z",
  transform: "translate(-1446.183 -1247.031)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path511",
  d: "M1680.165,1508.636a.015.015,0,0,1-.009,0,.014.014,0,0,1,0-.019.015.015,0,0,1,.008-.007l.907-.25h.006l.005,0,0,0a.01.01,0,0,1,0,.005.014.014,0,0,1,0,.006.012.012,0,0,1,0,.005l0,0-.005,0-.907.251Z",
  transform: "translate(-1380.335 -1252.306)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path513",
  d: "M1839.247,1482.831a.016.016,0,0,1-.009,0,.015.015,0,0,1,.006-.025l.275-.069a.015.015,0,0,1,.011,0,.014.014,0,0,1,.007.009.015.015,0,0,1-.011.017l-.275.069Z",
  transform: "translate(-1536.055 -1227.225)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path515",
  d: "M1769.969,1471.932a.015.015,0,0,1-.01,0,.014.014,0,0,1,0-.009.014.014,0,0,1,0-.01.014.014,0,0,1,.009-.006,7.981,7.981,0,0,0,1.462-.352h.011l0,0,0,.005a.015.015,0,0,1,0,.011.014.014,0,0,1-.009.007,7.973,7.973,0,0,1-1.469.354Z",
  transform: "translate(-1468.241 -1216.278)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path517",
  d: "M1908.454,1433.632a.014.014,0,0,1-.01,0,.015.015,0,0,1-.005-.008.016.016,0,0,1,0-.01.016.016,0,0,1,.008-.006l.486-.194a.015.015,0,0,1,.01,0,.015.015,0,0,1,.007.018.013.013,0,0,1-.007.008l-.486.193Z",
  transform: "translate(-1603.796 -1178.945)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path519",
  d: "M1858.579,1463.547a.014.014,0,0,1-.009,0,.014.014,0,0,1,0-.008.011.011,0,0,1,0-.006.009.009,0,0,1,0-.005l0,0,.005,0,.344-.069a.015.015,0,0,1,.01,0,.014.014,0,0,1,0,.02.015.015,0,0,1-.009.006l-.344.068Z",
  transform: "translate(-1554.977 -1208.348)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path521",
  d: "M1969.8,1401.677a.013.013,0,0,1-.008,0,.013.013,0,0,1-.005-.007.015.015,0,0,1,0-.011.015.015,0,0,1,.008-.008l1.121-.458h.011l0,0,0,0a.015.015,0,0,1,0,.011.014.014,0,0,1-.008.008l-1.121.458Z",
  transform: "translate(-1663.847 -1147.406)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path523",
  d: "M1938.974,1436.622l-.008,0a.014.014,0,0,1-.005-.007.014.014,0,0,1,0-.005.017.017,0,0,1,0-.006l0,0,0,0,.6-.252h.011l0,0,0,0a.014.014,0,0,1,0,.006.01.01,0,0,1,0,.005l0,0,0,0-.6.252Z",
  transform: "translate(-1633.672 -1181.813)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path525",
  d: "M2068.461,1370.552l-.008,0a.018.018,0,0,1-.006-.006.014.014,0,0,1,0-.005.013.013,0,0,1,0-.005l0-.005,0,0,.6-.3a.015.015,0,0,1,.011,0,.014.014,0,0,1,.008.007.015.015,0,0,1,0,.005.012.012,0,0,1,0,.006l0,0,0,0-.595.3-.007,0Z",
  transform: "translate(-1760.421 -1117.095)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path527",
  d: "M1409.764,1545.569h0l-.206-.046a.015.015,0,0,1-.009-.006.014.014,0,0,1,0-.011.015.015,0,0,1,.017-.011l.206.046a.016.016,0,0,1,.009.006.015.015,0,0,1,0,.011.015.015,0,0,1-.005.008.016.016,0,0,1-.009,0Z",
  transform: "translate(-1115.449 -1288.659)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path529",
  d: "M403.564,2468.077a.038.038,0,0,1-.021-.006,1.362,1.362,0,0,1-.528-.631.039.039,0,0,1,0-.03.039.039,0,0,1,.072,0,1.282,1.282,0,0,0,.5.6.038.038,0,0,1,.015.019.039.039,0,0,1,0,.024.04.04,0,0,1-.014.02.039.039,0,0,1-.023.008Z",
  transform: "translate(-130.201 -2191.059)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path531",
  d: "M295.209,1929.6a.038.038,0,0,1-.025-.009.039.039,0,0,1-.013-.023,1.45,1.45,0,0,1,.455-1.292.04.04,0,0,1,.013-.009.041.041,0,0,1,.015,0,.041.041,0,0,1,.015,0,.042.042,0,0,1,.013.009.039.039,0,0,1,.008.014.039.039,0,0,1,0,.031.039.039,0,0,1-.01.012,1.37,1.37,0,0,0-.43,1.222.039.039,0,0,1-.032.044Z",
  transform: "translate(-24.621 -1663.332)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path533",
  d: "M277.712,1939.039a.038.038,0,0,1-.039-.033,1.1,1.1,0,0,1,.066-.571.039.039,0,0,1,.05-.022.038.038,0,0,1,.021.021.039.039,0,0,1,0,.03,1.02,1.02,0,0,0-.061.531.041.041,0,0,1,0,.015.04.04,0,0,1-.018.024.04.04,0,0,1-.014.005Z",
  transform: "translate(-7.5 -1673.268)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path535",
  d: "M790.127,1538.962a.041.041,0,0,1-.017,0,6.872,6.872,0,0,1-1.147-.688.039.039,0,0,1,.046-.062,6.777,6.777,0,0,0,1.134.68.039.039,0,0,1,.021.043.038.038,0,0,1-.013.021.039.039,0,0,1-.024.009Z",
  transform: "translate(-507.975 -1281.52)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path537",
  d: "M875.382,1517.943l-.014,0a1.772,1.772,0,0,1-.562-.352.041.041,0,0,1-.01-.012.039.039,0,0,1,0-.031.038.038,0,0,1,.021-.023.039.039,0,0,1,.044.009,1.7,1.7,0,0,0,.537.336.038.038,0,0,1,.02.017.038.038,0,0,1,0,.026.039.039,0,0,1-.013.023.041.041,0,0,1-.025.009Z",
  transform: "translate(-592.004 -1261.276)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path539",
  d: "M917.172,1553.037a.04.04,0,0,1-.02-.005l-.23-.136a.039.039,0,0,1-.018-.024.039.039,0,0,1,.057-.043l.23.136a.04.04,0,0,1,.016.019.039.039,0,0,1,0,.025.04.04,0,0,1-.014.021.039.039,0,0,1-.023.008Z",
  transform: "translate(-633.226 -1295.833)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path541",
  d: "M2061.129,736.455l-.014,0a12.2,12.2,0,0,1-1.441-.68.042.042,0,0,1-.011-.01.038.038,0,0,1-.008-.029.039.039,0,0,1,.015-.026.041.041,0,0,1,.013-.007.039.039,0,0,1,.015,0,.038.038,0,0,1,.014,0,12.071,12.071,0,0,0,1.431.675.04.04,0,0,1,.02.017.038.038,0,0,1,0,.026.039.039,0,0,1-.013.023.038.038,0,0,1-.025.009Z",
  transform: "translate(-1751.815 -495.987)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path543",
  d: "M2030.994,784.415a.038.038,0,0,1-.017,0,4.389,4.389,0,0,1-.545-.326.036.036,0,0,1-.011-.011.035.035,0,0,1-.005-.014.04.04,0,0,1,0-.015.044.044,0,0,1,.006-.014.039.039,0,0,1,.054-.009,4.261,4.261,0,0,0,.535.32.037.037,0,0,1,.018.018.039.039,0,0,1-.011.046.038.038,0,0,1-.024.008Z",
  transform: "translate(-1723.194 -543.28)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path545",
  d: "M1023.728,1087.8h0a.014.014,0,0,1-.009-.007.014.014,0,0,1,0-.011l.158-.669,0-.005,0,0,.005,0h.006l.005,0,0,0a.015.015,0,0,1,0,.005.012.012,0,0,1,0,.005l-.158.669a.014.014,0,0,1-.014.011Z",
  transform: "translate(-737.777 -839.96)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path547",
  d: "M1024.656,1123.39h-.005a.016.016,0,0,1-.008-.007.015.015,0,0,1,0-.011l.172-.481a.013.013,0,0,1,.007-.008.014.014,0,0,1,.011,0l.005,0,0,0a.021.021,0,0,1,0,.006.012.012,0,0,1,0,.005l-.172.481a.015.015,0,0,1-.005.006l-.008,0Z",
  transform: "translate(-738.686 -874.982)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path549",
  d: "M1049.612,1096.6h-.005l0,0,0,0a.017.017,0,0,1,0-.005.014.014,0,0,1,0-.006l.205-.6,0,0,0,0h.011a.014.014,0,0,1,.009.018l-.205.6a.014.014,0,0,1-.005.006l-.008,0Z",
  transform: "translate(-763.114 -848.639)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path551",
  d: "M1024.389,1163.294h0a.015.015,0,0,1-.009-.007.014.014,0,0,1,0-.011l.191-.619a.013.013,0,0,1,.007-.007.015.015,0,0,1,.01,0,.014.014,0,0,1,.008.007.014.014,0,0,1,0,.01l-.191.619a.014.014,0,0,1-.006.007.015.015,0,0,1-.009,0Z",
  transform: "translate(-738.426 -913.908)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path553",
  d: "M1013.4,1171.179h0a.015.015,0,0,1-.008-.007.014.014,0,0,1,0-.011l.07-.223a.016.016,0,0,1,.007-.007.014.014,0,0,1,.01,0,.015.015,0,0,1,.01.017l-.07.223a.013.013,0,0,1-.005.007.014.014,0,0,1-.008,0Z",
  transform: "translate(-727.668 -922.013)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path555",
  d: "M1005.9,1143.59h0l-.005,0,0,0a.013.013,0,0,1,0-.005.012.012,0,0,1,0-.006l.12-.4,0-.005,0,0,.005,0h.005a.015.015,0,0,1,.01.018l-.121.4a.016.016,0,0,1-.005.007Z",
  transform: "translate(-720.327 -894.838)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path557",
  d: "M1041.238,1094.192l-.014,0a.039.039,0,0,1-.021-.02.04.04,0,0,1,0-.029l.067-.173a.039.039,0,0,1,.021-.021.038.038,0,0,1,.03,0,.039.039,0,0,1,.022.05l-.067.174a.038.038,0,0,1-.036.023Z",
  transform: "translate(-754.894 -846.654)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path559",
  d: "M2546.352,852.075a.015.015,0,0,1-.009-.005.015.015,0,0,1,0-.01.015.015,0,0,1,0-.01.015.015,0,0,1,.009-.005l.332-.027a.015.015,0,0,1,.011,0,.014.014,0,0,1,.005.01.016.016,0,0,1,0,.011.014.014,0,0,1-.01.005l-.332.027Z",
  transform: "translate(-2228.21 -609.847)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path561",
  d: "M2576.712,847.333h-.083l0,0,0,0a.021.021,0,0,1,0-.006.014.014,0,0,1,.015-.015h.077a.013.013,0,0,1,.01,0,.014.014,0,0,1,0,.01.011.011,0,0,1,0,.006.011.011,0,0,1,0,0l0,0Z",
  transform: "translate(-2257.85 -605.231)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path563",
  d: "M2548.6,845.167h-.092a.014.014,0,0,1-.009-.005.014.014,0,0,1,0-.019.014.014,0,0,1,.009-.005h.1l.006,0a.01.01,0,0,1,0,.005.014.014,0,0,1,0,.006.013.013,0,0,1,0,.006.01.01,0,0,1,0,.005l-.006,0Z",
  transform: "translate(-2230.324 -603.111)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path565",
  d: "M2150.086,1321.286a10.23,10.23,0,0,1-1.256.283c.242.035.14.031.376.12.715-.281,1.2-.418,1.2-.418Z",
  transform: "translate(-1839.105 -1069.176)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path567",
  d: "M1882.852,894.893a.087.087,0,0,1-.055-.02l-6.582-5.422a.087.087,0,0,1-.012-.123.088.088,0,0,1,.123-.012l6.534,5.38a20.455,20.455,0,0,0,8.892-14.162,4.949,4.949,0,0,0-.151-2.743c-.56-.619-2.309-.912-3.3-1.032a.087.087,0,1,1,.021-.173c1.017.123,2.813.428,3.41,1.088a4.958,4.958,0,0,1,.193,2.88,19.8,19.8,0,0,1-2.284,6.919,20.892,20.892,0,0,1-6.738,7.4A.09.09,0,0,1,1882.852,894.893Z",
  transform: "translate(-1572.222 -633.894)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path569",
  d: "M2506.994,706.233l.514-.59L2506.413,704s-.265.159-.818.529a1.431,1.431,0,0,1-.623.232c-.1.012-.212.027-.352.047-.091.013.034.319.3.467,0,0-.78.52-.714.667.309.7,1.546,1.375,2.1.745a.542.542,0,0,0,.7.2A.345.345,0,0,0,2506.994,706.233Z",
  transform: "translate(-2186.965 -464.956)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "path571",
  d: "M2504.188,704.34a.589.589,0,0,1-.448-.224.879.879,0,0,1-.773.206,2,2,0,0,1-1.38-1.014c-.066-.148.307-.448.661-.69a.6.6,0,0,1-.281-.448.088.088,0,0,1,.025-.052.089.089,0,0,1,.052-.026c.127-.018.246-.034.353-.047a1.378,1.378,0,0,0,.6-.221c.547-.366.818-.529.82-.531a.059.059,0,0,1,.078.017l1.094,1.645a.055.055,0,0,1,.01.036.057.057,0,0,1-.014.034l-.46.528a.408.408,0,0,1,.2.326.387.387,0,0,1-.258.4.734.734,0,0,1-.276.059Zm-.445-.368a.058.058,0,0,1,.024.006.06.06,0,0,1,.02.016.485.485,0,0,0,.632.18.27.27,0,0,0,.185-.284.278.278,0,0,0-.193-.255.06.06,0,0,1-.026-.014.059.059,0,0,1-.016-.025.058.058,0,0,1,0-.03.06.06,0,0,1,.013-.026l.485-.556-1.039-1.561c-.1.061-.354.221-.768.5a1.5,1.5,0,0,1-.648.24c-.1.012-.212.027-.33.044a.612.612,0,0,0,.3.361.056.056,0,0,1,.021.02.057.057,0,0,1,0,.057.06.06,0,0,1-.02.022,2.266,2.266,0,0,0-.692.6,1.867,1.867,0,0,0,1.291.944.765.765,0,0,0,.716-.217.06.06,0,0,1,.02-.014.058.058,0,0,1,.024,0Z",
  transform: "translate(-2184.395 -462.3)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path573",
  d: "M2583.639,731.579h-.01a.059.059,0,0,1-.038-.024.06.06,0,0,1-.009-.043,1.322,1.322,0,0,0,0-.454.058.058,0,0,1,.113-.024,1.4,1.4,0,0,1,0,.5.06.06,0,0,1-.021.034.06.06,0,0,1-.038.013Z",
  transform: "translate(-2264.664 -491.377)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path575",
  d: "M2620.4,820.019a.059.059,0,0,1-.047-.024l-.122-.167a.053.053,0,0,1-.01-.021.049.049,0,0,1,0-.023.062.062,0,0,1,.008-.022.06.06,0,0,1,.016-.017.058.058,0,0,1,.021-.01.056.056,0,0,1,.023,0,.058.058,0,0,1,.022.008.053.053,0,0,1,.016.016l.122.167a.054.054,0,0,1,.01.021.055.055,0,0,1,0,.023.056.056,0,0,1-.008.021.061.061,0,0,1-.015.017.06.06,0,0,1-.034.011Z",
  transform: "translate(-2300.522 -578.244)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path577",
  d: "M2621.133,824.676a.059.059,0,0,1-.055-.041.06.06,0,0,1,0-.036.057.057,0,0,1,.022-.029l.261-.171a.058.058,0,0,1,.044-.009.061.061,0,0,1,.021.009.062.062,0,0,1,.016.016.058.058,0,0,1,.009.021.061.061,0,0,1,0,.023.057.057,0,0,1-.01.021.059.059,0,0,1-.017.016l-.261.171a.058.058,0,0,1-.032.009Z",
  transform: "translate(-2301.365 -582.799)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path579",
  d: "M2561.968,741.95h-.011a.266.266,0,0,1-.206-.3.057.057,0,0,1,.008-.022.073.073,0,0,1,.016-.017.063.063,0,0,1,.021-.01.062.062,0,0,1,.023,0,.06.06,0,0,1,.048.045.06.06,0,0,1,0,.023.151.151,0,0,0,.114.163.06.06,0,0,1,.022.006.056.056,0,0,1,.018.014.053.053,0,0,1,.011.02.054.054,0,0,1,0,.023.061.061,0,0,1-.006.022.06.06,0,0,1-.014.018.061.061,0,0,1-.02.011.056.056,0,0,1-.022,0Z",
  transform: "translate(-2243.292 -501.766)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path581",
  d: "M2518.385,774.442a.058.058,0,0,0-.042-.071.4.4,0,0,1-.235-.23l-.015-.027a.05.05,0,0,0-.015-.018.057.057,0,0,0-.02-.011.059.059,0,0,0-.023,0,.058.058,0,0,0-.022.007.055.055,0,0,0-.017.015.056.056,0,0,0-.012.044.062.062,0,0,0,.008.022l.015.026a.5.5,0,0,0,.308.287.058.058,0,0,0,.071-.042Z",
  transform: "translate(-2200.454 -533.558)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path583",
  d: "M2571.655,669.5a.188.188,0,0,1-.278-.059c-.136-.176.482-.422.345-.706s-.464-.009-.57-.2.3-.63,0-.916-1.066-.572-.847-.892,1.7-.484,1.868.467c1.283-.275,1.954,2.019.613,1.76.193,1.135-.917.742-.917.742S2571.8,669.462,2571.655,669.5Z",
  transform: "translate(-2251.627 -428.219)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path585",
  d: "M2569.578,667.01a1.385,1.385,0,0,1-.411-.069.057.057,0,0,1-.023-.015.059.059,0,0,1-.013-.024s-.052-.158-.132-.155a.244.244,0,0,1-.158.039.282.282,0,0,1-.107-.04.279.279,0,0,1-.082-.079c-.095-.122.036-.25.151-.363.142-.139.239-.246.187-.353s-.138-.112-.271-.1c-.1.009-.232.021-.3-.1a.479.479,0,0,1,.036-.365c.064-.191.131-.389-.029-.536a2.712,2.712,0,0,0-.358-.256c-.259-.166-.5-.324-.541-.512a.251.251,0,0,1,.045-.2,1.367,1.367,0,0,1,1.2-.24.918.918,0,0,1,.764.672,1.123,1.123,0,0,1,1.107.529,1.1,1.1,0,0,1,.15,1.14.585.585,0,0,1-.619.228.711.711,0,0,1-.177.667A.639.639,0,0,1,2569.578,667.01Zm-.348-.171a.825.825,0,0,0,.689-.048.658.658,0,0,0,.125-.638.057.057,0,0,1,0-.028.057.057,0,0,1,.066-.039.52.52,0,0,0,.58-.165.989.989,0,0,0-.149-1.011,1.011,1.011,0,0,0-1.044-.471.058.058,0,0,1-.044-.009.056.056,0,0,1-.016-.016.061.061,0,0,1-.009-.021.8.8,0,0,0-.686-.636,1.277,1.277,0,0,0-1.077.191.139.139,0,0,0-.026.111c.028.141.274.3.49.438a2.81,2.81,0,0,1,.375.269c.214.2.128.453.06.657-.039.112-.073.218-.044.273s.075.051.186.041a.333.333,0,0,1,.387.165c.094.191-.077.354-.211.486-.1.1-.17.171-.14.209a.168.168,0,0,0,.11.074.127.127,0,0,0,.085-.024.064.064,0,0,1,.024-.012c.142-.033.232.1.271.2Z",
  transform: "translate(-2248.947 -425.417)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path587",
  d: "M495.38,1085.563c.212-.084.269-.443.127-.8s-.429-.581-.64-.5-.269.443-.127.8S495.168,1085.646,495.38,1085.563Z",
  transform: "translate(-219.911 -837.164)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path589",
  d: "M492.627,1082.918a.476.476,0,0,1-.287-.113,1.043,1.043,0,0,1-.312-.439c-.155-.394-.086-.779.159-.876a.409.409,0,0,1,.4.091,1.041,1.041,0,0,1,.312.439c.155.395.086.779-.159.876A.317.317,0,0,1,492.627,1082.918Zm-.324-1.334a.2.2,0,0,0-.073.014c-.179.071-.222.4-.094.725a.926.926,0,0,0,.276.39.3.3,0,0,0,.29.075c.179-.071.222-.4.094-.726a.929.929,0,0,0-.276-.39A.364.364,0,0,0,492.3,1081.584Z",
  transform: "translate(-217.253 -834.444)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path591",
  d: "M1227.924,450.74c.15-.172.035-.516-.256-.77s-.648-.319-.8-.147-.035.516.256.77S1227.774,450.912,1227.924,450.74Z",
  transform: "translate(-936.575 -216.06)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path593",
  d: "M1224.872,448.229a.633.633,0,0,1-.116-.011,1.129,1.129,0,0,1-.789-.687.367.367,0,0,1,.449-.515,1.043,1.043,0,0,1,.479.246h0a1.043,1.043,0,0,1,.309.441.409.409,0,0,1-.049.411.364.364,0,0,1-.284.116Zm-.57-1.108a.254.254,0,0,0-.2.077.3.3,0,0,0-.026.3,1.013,1.013,0,0,0,.7.61.3.3,0,0,0,.292-.067.3.3,0,0,0,.026-.3,1.011,1.011,0,0,0-.7-.61.51.51,0,0,0-.094-.012Z",
  transform: "translate(-933.765 -213.396)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path595",
  d: "M412.513,1007.878a.335.335,0,0,0,.223-.406c-.027-.2-.17-.354-.32-.334a.335.335,0,0,0-.223.406C412.22,1007.748,412.363,1007.9,412.513,1007.878Z",
  transform: "translate(-139.182 -761.684)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path597",
  d: "M410.834,1006.29a.406.406,0,0,1-.352-.386.508.508,0,0,1,.052-.309.3.3,0,0,1,.221-.163c.182-.023.355.148.387.385a.392.392,0,0,1-.273.471l-.034,0Zm-.045-.745h-.019a.186.186,0,0,0-.135.1.387.387,0,0,0-.039.237c.022.17.139.3.256.285s.2-.172.173-.341-.127-.285-.237-.285Z",
  transform: "translate(-137.506 -760.012)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path599",
  d: "M538.016,1221.222a.392.392,0,1,0-.415-.206A.336.336,0,0,0,538.016,1221.222Z",
  transform: "translate(-261.89 -970.57)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path601",
  d: "M535.233,1218.435a.447.447,0,0,1-.371-.26.507.507,0,0,1-.056-.309.284.284,0,0,1,.291-.26.289.289,0,0,1,.136.039.533.533,0,0,1,.274.531.3.3,0,0,1-.152.229.267.267,0,0,1-.123.031Zm-.15-.71a.153.153,0,0,0-.071.017.186.186,0,0,0-.091.144.391.391,0,0,0,.044.236c.077.152.232.235.337.181a.184.184,0,0,0,.063-.061.187.187,0,0,0,.028-.083.386.386,0,0,0-.044-.236h0a.39.39,0,0,0-.167-.173.225.225,0,0,0-.1-.025Z",
  transform: "translate(-259.203 -967.703)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path603",
  d: "M602.343,1870.429a.277.277,0,1,0-.4.118A.3.3,0,0,0,602.343,1870.429Z",
  transform: "translate(-324.81 -1606.28)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path605",
  d: "M599.42,1867.893a.3.3,0,0,1-.165-.048.376.376,0,0,1,.4-.629.307.307,0,0,1,.094.1.311.311,0,0,1,.045.127.408.408,0,0,1-.282.44.347.347,0,0,1-.1.014Zm-.145-.48a.239.239,0,0,0,.043.334.2.2,0,0,0,.165.02.292.292,0,0,0,.2-.312.2.2,0,0,0-.087-.142.24.24,0,0,0-.321.1Z",
  transform: "translate(-322.154 -1603.532)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path607",
  d: "M480.74,2220.282a.277.277,0,1,0-.313.277A.3.3,0,0,0,480.74,2220.282Z",
  transform: "translate(-205.749 -1948.836)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path609",
  d: "M477.8,2218.125l-.039,0a.313.313,0,0,1-.221-.143.4.4,0,0,1-.06-.271.335.335,0,1,1,.659.088.4.4,0,0,1-.128.247A.318.318,0,0,1,477.8,2218.125Zm.019-.631a.246.246,0,0,0-.224.229.281.281,0,0,0,.041.193.189.189,0,0,0,.06.061.193.193,0,0,0,.08.03.192.192,0,0,0,.158-.052.283.283,0,0,0,.09-.175.24.24,0,0,0-.18-.284l-.024,0Z",
  transform: "translate(-203.094 -1946.338)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path611",
  d: "M472.839,2408.64a.277.277,0,1,0-.313.277A.3.3,0,0,0,472.839,2408.64Z",
  transform: "translate(-198.015 -2133.212)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path613",
  d: "M469.882,2406.509a.256.256,0,0,1-.039,0,.313.313,0,0,1-.221-.143.4.4,0,0,1-.059-.271h0a.334.334,0,1,1,.658.087A.361.361,0,0,1,469.882,2406.509Zm.02-.631a.246.246,0,0,0-.224.229.281.281,0,0,0,.041.193.194.194,0,0,0,.059.061.2.2,0,0,0,.08.031.262.262,0,0,0,.068-.511l-.024,0Z",
  transform: "translate(-195.34 -2130.739)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path615",
  d: "M559.642,2220.292a.277.277,0,1,0-.313.277A.3.3,0,0,0,559.642,2220.292Z",
  transform: "translate(-282.982 -1948.846)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path617",
  d: "M556.724,2218.125l-.039,0a.316.316,0,0,1-.221-.143.4.4,0,0,1-.06-.271.335.335,0,1,1,.659.088.4.4,0,0,1-.128.247A.318.318,0,0,1,556.724,2218.125Zm.019-.631a.246.246,0,0,0-.224.229.283.283,0,0,0,.041.193.189.189,0,0,0,.06.061.192.192,0,0,0,.08.03.192.192,0,0,0,.158-.052.283.283,0,0,0,.09-.175.24.24,0,0,0-.181-.284l-.024,0Z",
  transform: "translate(-280.346 -1946.338)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path619",
  d: "M560.43,2375.376a.259.259,0,1,0-.293.26A.278.278,0,0,0,560.43,2375.376Z",
  transform: "translate(-283.788 -2100.672)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path621",
  d: "M557.424,2373.192l-.039,0a.337.337,0,0,1-.266-.392.377.377,0,0,1,.121-.232.293.293,0,0,1,.11-.065.3.3,0,0,1,.127-.013.336.336,0,0,1,.265.392A.34.34,0,0,1,557.424,2373.192Zm.019-.591a.188.188,0,0,0-.123.05.261.261,0,0,0-.083.162.2.2,0,1,0,.229-.21Z",
  transform: "translate(-281.046 -2098.165)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path623",
  d: "M412.69,2042.454a.2.2,0,1,0-.233-.2A.219.219,0,0,0,412.69,2042.454Z",
  transform: "translate(-139.445 -1774.716)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path625",
  d: "M410,2039.83a.261.261,0,1,1,.29-.26A.277.277,0,0,1,410,2039.83Zm0-.4a.146.146,0,1,0,.174.144.162.162,0,0,0-.174-.144Z",
  transform: "translate(-136.76 -1772.034)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path627",
  d: "M655.5,1987.96a.277.277,0,1,0-.417.029A.3.3,0,0,0,655.5,1987.96Z",
  transform: "translate(-376.872 -1721.291)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path629",
  d: "M652.6,1985.487a.313.313,0,0,1-.12-.022.31.31,0,0,1-.1-.067.355.355,0,0,1,.029-.5.4.4,0,0,1,.252-.116.308.308,0,0,1,.319.2.309.309,0,0,1,.016.134.407.407,0,0,1-.395.37Zm-.111-.506a.22.22,0,1,0,.306.306.284.284,0,0,0,.084-.178.193.193,0,0,0-.128-.2.192.192,0,0,0-.085-.01.282.282,0,0,0-.178.084Z",
  transform: "translate(-374.204 -1718.657)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path631",
  d: "M510.1,959.806a.336.336,0,0,0,.223-.406c-.027-.2-.171-.355-.321-.335a.336.336,0,0,0-.223.406C509.807,959.676,509.951,959.826,510.1,959.806Z",
  transform: "translate(-234.706 -714.627)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path633",
  d: "M507.308,957.207a.406.406,0,0,1-.352-.387.393.393,0,0,1,.273-.471c.181-.024.355.148.387.385a.509.509,0,0,1-.052.309.3.3,0,0,1-.221.164Zm-.045-.745h-.019c-.116.015-.193.172-.173.341s.139.3.256.285a.185.185,0,0,0,.135-.1.391.391,0,0,0,.039-.237h0c-.02-.159-.126-.285-.235-.285Z",
  transform: "translate(-231.941 -711.968)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path635",
  d: "M1122.872,434.571a.392.392,0,1,0-.458-.071A.336.336,0,0,0,1122.872,434.571Z",
  transform: "translate(-834.259 -200.645)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path637",
  d: "M1119.9,431.885a.378.378,0,0,1-.058,0,.533.533,0,0,1-.422-.423.284.284,0,0,1,.341-.34.505.505,0,0,1,.275.147h0a.5.5,0,0,1,.147.276.3.3,0,0,1-.077.264.284.284,0,0,1-.2.08Zm-.2-.657a.172.172,0,0,0-.124.047c-.083.083-.051.255.07.376s.293.155.376.07a.185.185,0,0,0,.043-.165.385.385,0,0,0-.114-.211h0a.392.392,0,0,0-.211-.116h-.04Z",
  transform: "translate(-831.452 -197.837)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path639",
  d: "M587.762,1166.7a.336.336,0,0,0,.117-.449c-.076-.192-.252-.3-.392-.247a.336.336,0,0,0-.117.448C587.446,1166.644,587.621,1166.755,587.762,1166.7Z",
  transform: "translate(-310.625 -917.178)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path641",
  d: "M585.062,1164.043a.433.433,0,0,1-.371-.3.344.344,0,1,1,.618-.244.5.5,0,0,1,.025.309.3.3,0,0,1-.175.213.26.26,0,0,1-.1.02Zm-.124-.724a.146.146,0,0,0-.055.01c-.109.043-.148.214-.085.374s.208.257.318.214a.183.183,0,0,0,.069-.054.186.186,0,0,0,.037-.08.387.387,0,0,0-.021-.239h0A.327.327,0,0,0,584.938,1163.319Z",
  transform: "translate(-308 -914.451)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path643",
  d: "M501.169,1980.52c.359-.142.581-.429.5-.641s-.442-.269-.8-.127-.581.429-.5.641S500.81,1980.662,501.169,1980.52Z",
  transform: "translate(-225.479 -1713.659)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path645",
  d: "M498.173,1977.97a.467.467,0,0,1-.467-.242.409.409,0,0,1,.091-.4,1.046,1.046,0,0,1,.439-.312h0a1.046,1.046,0,0,1,.534-.073.367.367,0,0,1,.251.635,1.041,1.041,0,0,1-.439.313,1.125,1.125,0,0,1-.409.083Zm.469-.924a1.006,1.006,0,0,0-.364.074h0a.929.929,0,0,0-.39.274.3.3,0,0,0-.075.29c.07.179.4.222.725.094a.925.925,0,0,0,.39-.275.254.254,0,0,0-.178-.449.669.669,0,0,0-.109-.007Z",
  transform: "translate(-222.87 -1710.974)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path647",
  d: "M504.723,2291.665c.059-.328-.047-.621-.236-.655s-.39.2-.449.531.047.621.236.655S504.664,2291.992,504.723,2291.665Z",
  transform: "translate(-229.074 -2018.409)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path649",
  d: "M501.594,2289.713a.3.3,0,0,1-.047,0,.354.354,0,0,1-.256-.255.924.924,0,0,1-.027-.467h0a.928.928,0,0,1,.189-.428.355.355,0,0,1,.328-.149c.224.039.348.357.283.721C502,2289.469,501.8,2289.713,501.594,2289.713Zm.14-1.192a.269.269,0,0,0-.193.113.808.808,0,0,0-.163.374h0a.812.812,0,0,0,.022.407c.039.1.1.167.167.18.155.027.329-.193.382-.484s-.034-.559-.189-.587Z",
  transform: "translate(-226.357 -2015.862)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path651",
  d: "M2378.079,2582.97c.264-.2.383-.49.266-.643s-.426-.112-.69.091-.383.49-.266.643S2377.815,2583.173,2378.079,2582.97Z",
  transform: "translate(-2062.787 -2303.48)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path653",
  d: "M2374.832,2580.8a.33.33,0,0,1-.271-.116.352.352,0,0,1-.017-.36.928.928,0,0,1,.294-.364h0a.923.923,0,0,1,.427-.19.316.316,0,0,1,.361.47.923.923,0,0,1-.294.364A.858.858,0,0,1,2374.832,2580.8Zm.077-.748a.809.809,0,0,0-.258.316.247.247,0,0,0,0,.245c.1.125.375.077.608-.1a.808.808,0,0,0,.258-.316.245.245,0,0,0,0-.246.243.243,0,0,0-.236-.065.8.8,0,0,0-.372.167Z",
  transform: "translate(-2060.007 -2301.061)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path655",
  d: "M2436.449,2481.921c.132,0,.239-.143.239-.321s-.107-.32-.239-.32-.239.143-.239.32S2436.317,2481.921,2436.449,2481.921Z",
  transform: "translate(-2120.409 -2204.659)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path657",
  d: "M2433.737,2479.287a.39.39,0,1,1,.3-.379A.346.346,0,0,1,2433.737,2479.287Zm0-.641c-.1,0-.181.12-.181.262s.083.262.181.262.18-.12.18-.262-.083-.262-.18-.262Z",
  transform: "translate(-2117.697 -2201.967)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path659",
  d: "M2269.691,2615.06c.177-.014.311-.132.3-.264a.288.288,0,0,0-.339-.212c-.176.014-.311.132-.3.264A.288.288,0,0,0,2269.691,2615.06Z",
  transform: "translate(-1957.078 -2335.143)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path661",
  d: "M2266.967,2612.418a.338.338,0,0,1-.363-.267.346.346,0,0,1,.354-.326.434.434,0,0,1,.266.06.268.268,0,0,1,.134.205.345.345,0,0,1-.353.326Zm0-.478c-.142.011-.255.1-.247.2s.134.17.277.159.255-.1.247-.2a.153.153,0,0,0-.026-.068.149.149,0,0,0-.054-.048.322.322,0,0,0-.2-.043Z",
  transform: "translate(-1954.389 -2332.441)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path663",
  d: "M2311.792,2651.29c.176-.014.311-.133.3-.264a.288.288,0,0,0-.338-.212c-.177.014-.311.133-.3.264A.289.289,0,0,0,2311.792,2651.29Z",
  transform: "translate(-1998.289 -2370.606)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path665",
  d: "M2309.054,2648.673a.43.43,0,0,1-.227-.062.258.258,0,0,1-.093-.085.254.254,0,0,1-.041-.12.249.249,0,0,1,.021-.124.254.254,0,0,1,.078-.1.46.46,0,0,1,.521-.042.256.256,0,0,1,.134.205.255.255,0,0,1-.021.125.252.252,0,0,1-.078.1.438.438,0,0,1-.253.1Zm.032-.479h-.03a.322.322,0,0,0-.187.074.139.139,0,0,0-.048.056.146.146,0,0,0-.013.072.14.14,0,0,0,.08.116.346.346,0,0,0,.382-.031.157.157,0,0,0,.045-.057.16.16,0,0,0,.015-.071.155.155,0,0,0-.08-.116A.31.31,0,0,0,2309.085,2648.193Z",
  transform: "translate(-1995.587 -2367.93)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path667",
  d: "M2496.569,2542.861c.132,0,.239-.144.239-.321s-.107-.321-.239-.321-.239.144-.239.321S2496.437,2542.861,2496.569,2542.861Z",
  transform: "translate(-2179.258 -2264.311)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path669",
  d: "M2493.9,2540.256a.389.389,0,1,1,.3-.378A.345.345,0,0,1,2493.9,2540.256Zm0-.641c-.1,0-.18.12-.18.262s.083.263.18.263.181-.12.181-.263S2493.995,2539.616,2493.9,2539.616Z",
  transform: "translate(-2176.585 -2261.648)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path671",
  d: "M947.521,741.337a7.984,7.984,0,0,0-3.283-2.816,4.829,4.829,0,0,1-.71,2.418,18.976,18.976,0,0,0,3.539,1.3Z",
  transform: "translate(-659.287 -498.748)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path673",
  d: "M944.346,739.606a19.708,19.708,0,0,1-3.53-1.306.057.057,0,0,1-.031-.035.058.058,0,0,1,0-.046,4.821,4.821,0,0,0,.7-2.386.058.058,0,0,1,.023-.049.057.057,0,0,1,.026-.011.057.057,0,0,1,.028,0,8.1,8.1,0,0,1,3.313,2.839.059.059,0,0,1,.01.029.057.057,0,0,1-.006.029l-.454.9a.058.058,0,0,1-.019.022.057.057,0,0,1-.027.01Zm-3.424-1.386a17.476,17.476,0,0,0,3.419,1.27h0l.425-.841a7.994,7.994,0,0,0-3.157-2.738A5.054,5.054,0,0,1,940.922,738.221Z",
  transform: "translate(-656.599 -496.057)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path675",
  d: "M1167.666,238.823a24.654,24.654,0,0,1-3.286-5.084,5.543,5.543,0,0,0,3.127,0c1.58-.515,1.977-.687,1.977-.687a13.655,13.655,0,0,0-.318,4.079.387.387,0,0,0-.517.158l-.874,1.647Z",
  transform: "translate(-875.47 -3.966)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path677",
  d: "M1163.645,235.057a.088.088,0,0,1-.034-.007.087.087,0,0,1-.029-.02l-.106-.112,0,0a24.987,24.987,0,0,1-3.3-5.1.089.089,0,0,1-.007-.05.088.088,0,0,1,.065-.071.087.087,0,0,1,.05,0,5.494,5.494,0,0,0,3.072,0c1.555-.507,1.965-.683,1.969-.684a.087.087,0,0,1,.047-.006.086.086,0,0,1,.043.019.084.084,0,0,1,.027.039.086.086,0,0,1,0,.047,13.564,13.564,0,0,0-.317,4.044.087.087,0,0,1-.033.085.087.087,0,0,1-.091.009.3.3,0,0,0-.4.121l-.877,1.645a.086.086,0,0,1-.027.031.089.089,0,0,1-.038.015Zm-.041-.258.021.023.818-1.54a.439.439,0,0,1,.485-.241,13.447,13.447,0,0,1,.307-3.814c-.23.088-.756.279-1.83.629a5.555,5.555,0,0,1-3,.053A24.942,24.942,0,0,0,1163.6,234.8Z",
  transform: "translate(-871.342)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path679",
  d: "M1210.46,274.7a4.473,4.473,0,0,0,2-.034c1.284-.348,1.375-.558,1.375-.558a17.59,17.59,0,0,0,.089,3.207s-.13.06-.376.56c-.13.264-.516.973-.516.973A12.934,12.934,0,0,1,1210.46,274.7Z",
  transform: "translate(-920.575 -44.15)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path681",
  d: "M1210.337,275.973a.058.058,0,0,1-.023,0,.062.062,0,0,1-.019-.013,13.109,13.109,0,0,1-2.581-4.168.058.058,0,0,1,0-.031.06.06,0,0,1,.014-.027.058.058,0,0,1,.057-.017,4.481,4.481,0,0,0,1.968-.034c1.139-.309,1.319-.5,1.338-.528a.054.054,0,0,1,.025-.031.052.052,0,0,1,.038-.006.061.061,0,0,1,.048.065,17.749,17.749,0,0,0,.088,3.193.058.058,0,0,1-.005.037.058.058,0,0,1-.027.026,1.465,1.465,0,0,0-.348.533c-.129.262-.512.967-.516.975a.058.058,0,0,1-.018.02.057.057,0,0,1-.025.01Zm-2.481-4.126a12.988,12.988,0,0,0,2.468,3.97c.1-.186.372-.689.476-.9a1.8,1.8,0,0,1,.365-.56,17.037,17.037,0,0,1-.09-3.048,4.876,4.876,0,0,1-1.295.481A4.5,4.5,0,0,1,1207.857,271.846Z",
  transform: "translate(-917.884 -41.222)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path683",
  d: "M1305.457,369.491c.223-.045.342-.389.265-.766s-.32-.647-.544-.6-.342.389-.265.766S1305.234,369.537,1305.457,369.491Z",
  transform: "translate(-1013.009 -136.176)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path685",
  d: "M1302.64,366.893a.441.441,0,0,1-.319-.166,1.051,1.051,0,0,1-.232-.487c-.084-.415.052-.782.309-.834s.527.232.612.647-.052.782-.309.835a.3.3,0,0,1-.061.006Zm-.178-1.378a.214.214,0,0,0-.039,0c-.188.039-.289.358-.219.7a.931.931,0,0,0,.2.431.3.3,0,0,0,.271.124c.188-.039.289-.358.22-.7-.063-.315-.257-.559-.435-.559Z",
  transform: "translate(-1010.242 -133.515)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path687",
  d: "M1357.26,268.359c.151-.006.267-.178.259-.385s-.138-.369-.289-.363-.267.178-.259.385S1357.109,268.365,1357.26,268.359Z",
  transform: "translate(-1063.988 -37.795)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path689",
  d: "M1353.985,260.73a.4.4,0,0,1-.34-.417.508.508,0,0,1,.077-.3.3.3,0,0,1,.236-.142.393.393,0,0,1,.351.417.508.508,0,0,1-.077.3.3.3,0,0,1-.235.144Zm-.015-.746h-.007a.184.184,0,0,0-.143.092.389.389,0,0,0-.059.232c.008.171.114.312.23.306a.186.186,0,0,0,.143-.092.388.388,0,0,0,.059-.232C1354.186,260.121,1354.084,259.984,1353.97,259.984Z",
  transform: "translate(-1060.732 -30.215)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path691",
  d: "M1203.16,289.573a.336.336,0,0,0,.1-.452c-.082-.19-.26-.3-.4-.235a.336.336,0,0,0-.1.452C1202.842,289.527,1203.021,289.633,1203.16,289.573Z",
  transform: "translate(-912.999 -58.603)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path693",
  d: "M1200.41,287.013a.438.438,0,0,1-.372-.287.344.344,0,1,1,.61-.262.506.506,0,0,1,.034.309.3.3,0,0,1-.168.217.256.256,0,0,1-.1.022Zm-.132-.72a.147.147,0,0,0-.059.012c-.108.046-.142.218-.074.375s.216.251.323.2a.186.186,0,0,0,.1-.137.388.388,0,0,0-.026-.238h0a.331.331,0,0,0-.266-.218Z",
  transform: "translate(-910.33 -55.968)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path695",
  d: "M936.668,837.737c.05-.143-.068-.314-.262-.382a.336.336,0,0,0-.443.135c-.05.143.068.314.262.382A.336.336,0,0,0,936.668,837.737Z",
  transform: "translate(-651.87 -595.465)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path697",
  d: "M933.689,835.22a.528.528,0,0,1-.177-.031.391.391,0,0,1-.3-.456.3.3,0,0,1,.2-.183.505.505,0,0,1,.312.012h0a.509.509,0,0,1,.252.185.3.3,0,0,1,.046.271A.34.34,0,0,1,933.689,835.22Zm-.137-.573a.332.332,0,0,0-.1.014.186.186,0,0,0-.129.111c-.039.111.065.252.227.309s.331.011.369-.1a.184.184,0,0,0-.032-.167.39.39,0,0,0-.193-.141h0a.442.442,0,0,0-.142-.026Z",
  transform: "translate(-649.177 -592.727)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path699",
  d: "M1030.826,825.728c.114-.2-.064-.514-.4-.706s-.7-.189-.811.008.064.514.4.706S1030.712,825.926,1030.826,825.728Z",
  transform: "translate(-743.522 -583.281)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path701",
  d: "M1027.79,823.276a1.046,1.046,0,0,1-.51-.151c-.367-.212-.551-.557-.42-.785a.409.409,0,0,1,.372-.179,1.055,1.055,0,0,1,.518.15h0c.367.212.551.557.419.785A.415.415,0,0,1,1027.79,823.276Zm-.549-1h-.007a.3.3,0,0,0-.273.121c-.1.166.077.453.377.627s.635.179.731.013-.077-.453-.377-.627a.933.933,0,0,0-.452-.134Z",
  transform: "translate(-740.816 -580.62)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path703",
  d: "M967.571,733.166a.392.392,0,1,0-.446-.125A.336.336,0,0,0,967.571,733.166Z",
  transform: "translate(-682.287 -492.885)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path705",
  d: "M964.867,730.451a.471.471,0,0,1-.355-.193.344.344,0,1,1,.528.136.277.277,0,0,1-.172.058Zm-.187-.678a.16.16,0,0,0-.1.033c-.092.072-.081.247.024.382s.273.188.365.116.081-.247-.025-.382a.358.358,0,0,0-.265-.148Z",
  transform: "translate(-679.718 -490.071)",
  fill: "#13484f"
}))));
export default __webpack_public_path__ + "static/media/MoverIllustrationShaker.d4656e68.svg";
export { SvgComponent as ReactComponent };